import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from '@angular/material/dialog';
// import { BackendApiService } from 'src/app/services/backend-api.service';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { DialogGraphscaleSettingsComponent } from '../dialog-graphscale-settings/dialog-graphscale-settings.component';
import { DialogGraphscaleVpfSettingsComponent } from '../dialog-graphscale-vpf-settings/dialog-graphscale-vpf-settings.component';
import { MatSnackBar, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import moment from 'moment';
import { EnergyMeterService } from '../../../app/services/energymeter.service';
import { CommonModule } from '@angular/common';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { GaugeChartComponent } from '../device-detail-nxt/gauge-chart-component/gauge-chart-component.component';
import { MeterOperationalKpisComponent } from './meter-operational-kpis/meter-operational-kpis.component';
import { MeterServiceComponent } from './meter-service/meter-service.component';
import { LineChartComponent } from '../line-chart/line-chart.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';


@Component({
  selector: 'app-energy-meter-monitoring',
  templateUrl: './energy-meter-monitoring.component.html',
  styleUrls: ['./energy-meter-monitoring.component.scss'],
  standalone: true,
  imports:[CommonModule,MatIcon,NgbNavModule,NgbModule,GaugeChartComponent,MeterOperationalKpisComponent,MeterServiceComponent,MatIconModule,LineChartComponent,MatMenuModule,MatTooltip,MatTooltipModule,MatIconModule,MatIcon,MatButtonModule]
})
export class EnergyMeterMonitoringComponent implements OnInit {
  

  public today: any;
  public emLastDataTime: any;

  //Oil Temperature Radial-Gauge. 
  public eTxformerOilTemperatureData: any = [];
  //Oil Level Radial-Gauge. 
  public eTxformerOilLevelData: any = [];
  //Winding Temperature Radial-Gauge. 
  public tXformerWendingTemperatureData: any;

  
  public tXformerTrendsOilTemperatureData: any;
  public tXformerTrendsOilLevelData: any;
  public tXformerTrendsWindingTemperatureData: any;
  public tXformerTrendsPressureReliefValveData: any;
  public tXformerTrendsBuchholzRelayData: any;
  public tXformerTrendsSurgeRelayData: any;

  //Energy Meter Screen Line Chart.
  //Voltage
  public emVoltageLineData: any;
  public VoltageLineChartOptions="";
  public VoltageLineChartColors:any;
  public emVoltageLineMovingCount:any;
  public emVoltageLineMovingAvg:any;
  public emVoltageLineUnit:any;

  //Current
  public emCurrentLineData: any;
  public CurrentLineChartOptions="";
  public CurrentLineChartColors:any;
  public emCurrentLineMovingCount:any;
  public emCurrentLineMovingAvg:any;
  public emCurrentLineUnit:any;

  //Frequency
  public emFrequencyLineData: any;
  public FrequencyLineChartOptions="";
  public FrequencyLineChartColors:any;
  public emFrequencyMovingCount:any;
  public emFrequencyMovingAvg:any;
  public emFrequencyLineUnit:any;
  
  //Power Factor
  public emPowerFactorLineData: any;
  public PowerFactorLineChartOptions="";
  public PowerFactorLineChartColors:any;  
  public emPowerFactorMovingCount:any;
  public emPowerFactorMovingAvg:any;
  public emPowerFactorLineUnit:any;

  //KW Demand
  public emKwDemandLineData: any;
  public KwDemandLineChartOptions="";
  public KwDemandLineChartColors:any;
  public emKwDemandMovingCount:any;
  public emKwDemandMovingAvg:any;
  public emKwDemandLineUnit:any;

  //KVA Demand
  public emKvaDemandLineData: any;
  public KvaDemandLineChartOptions="";
  public KvaDemandLineChartColors:any;
  public emKvaDemandMovingCount:any;
  public emKvaDemandMovingAvg:any;
  public emKvaDemandLineUnit:any;
  
  //%THD
  public emTHDLineData: any;
  public THDLineChartOptions="";
  public THDLineChartColors:any;
  public emTHDLineMovingCount:any;
  public emTHDLineMovingAvg:any;
  public emTHDLineUnit:any;

  //Cumulative Energy

  public emCumulativeEnergyLineData: any;
  public CumulativeEnergyLineChartOptions="";
  public CumulativeEnergyLineChartColors:any;
  public emCumulativeEnergyLineMovingCount:any;
  public emCumulativeEnergyLineMovingAvg:any;
  public emCumulativeEnergyLineUnit:any;

  //Setting IDS. 
  public threePhaseLoadCurrentSettingID = 0;
  public threePhaseLineVoltageSettingID = 0;
  public powerFactor_FrequencySettingID = 0;
  public THDSettingID = 0;
  public KWHSettingID = 0;  
  public peakDemandKW_PeakDemandKVA_SettingID = 0;


  public TrendsOilTemperatureLineChartOptions="";
  public TrendsOilLevelLineChartOptions="";
  public TrendsWindingTemperatureLineChartOptions="";
  public TrendsPressureReliefValveLineChartOptions="";
  public TrendsBuchholzRelayLineChartOptions="";
  public TrendsSurgeRelayLineChartOptions="";

  public TrendsOilTemperatureLineChartColors:any;
  public TrendsOilLevelLineChartColors:any;
  public TrendsWindingTemperatureLineChartColors:any;
  public TrendsPressureReliefValveLineChartColors:any;
  public TrendsBuchholzRelayLineChartColors:any;
  public TrendsSurgeRelayLineChartColors:any;

  //Enerty Meter:: Gauge :: 3 Phase Load Current.
  public em3PhaseLoadCurrentData: any = [];
  public em3PhaseLoadCurrentGreenBar:number=0;
  public em3PhaseLoadCurrentYellowBar:number=0;
  public em3PhaseLoadCurrentRedBar:number=0;

  public em3PhaseLoadCurrentGreenText:any="";
  public em3PhaseLoadCurrentYellowText:any="";
  public em3PhaseLoadCurrentRedText:any="";
  public em3PhaseLoadCurrentAvg:any=0;
  public em3PhaseLoadCurrentAvgPer:any=0;
  public em3PhaseLoadCurrentCol:string="";
  public em3PhaseLoadCurrentColPercentage:any="";


  public BalancingDataGadge: any;
  
  //Enerty Meter:: Gauge :: 3 Phase Line Voltage.
  public em3PhaseLineVoltageData: any = [];
  public em3PhaseLineVoltageGreenBar:any=0;
  public em3PhaseLineVoltageYellowBar:any=0;
  public em3PhaseLineVoltageRedBar:any=0;
  
  public em3PhaseLineVoltageGreenText:any="";
  public em3PhaseLineVoltageYellowText:any="";
  public em3PhaseLineVoltageRedText:any="";
  public em3PhaseLineVoltageAvg:any=0;
  public em3PhaseLineVoltageAvgPer:any=0;
  public em3PhaseLineVoltageCol:string="";
  public em3PhaseLineVoltageColPercentage:any="";
  
  

    //Enerty Meter:: Gauge :: Cumulative Energy.
    public emPowerFactorFrequencyData: any = [];

  //Enerty Meter:: Gauge :: Total Harmonic Distortion.
  public TotalHarmonicDistortionData: any =[];

  //Enerty Meter:: Gauge :: Cumulative Energy .
  public CumulativeEnergyData: any =[];

   //Enerty Meter:: Gauge :: Peak Demand.
   public emPeakDemandData: any =[]; 

   //Graph Min Max Graph Scale Settings.
   public settings: any;
   public GraphScaleSettingData: any;

   //spinner.
   windingtemperatureloading: boolean = true;
   trendsoiltemperatureloading: boolean = true;
   trendsoillevelloading: boolean = true;
   trendswindingtemperatureloading: boolean = true;
   trendspressurereliefvalveloading: boolean = true;
   trendsbuchholzrelayloading: boolean = true;
   trendssurgerelayloading: boolean = true;

   threephaseloadcurrentloading: boolean = true;
   threephaselinevoltageloading: boolean = true;   
   powerfactorloading: boolean = true;
   totalharmonicdistortionloading: boolean = true;   
   public cumulativeenergyloading: boolean = true;
   peakdemandloading: boolean = true;
   
   trendsvoltageloading: boolean = true;
   trendscurrentloading: boolean = true;
   trendsfrequencyloading: boolean = true;
   trendspowerfactorloading: boolean = true;
   trendskwdemandloading: boolean = true;
   trendskvademandloading: boolean = true;
   trendsCumulativeEnergyloading: boolean = true;
   trendshtdloading: boolean = true;

   public powerFactorStripLines=[];
   public frequencyStripLines=[];
   public voltageStripLines=[];
   public kwStripLines=[];
   public kvaStripLines=[];

   
  public deviceMaker :any
  public emeterData = BaseUrlConstantsService.energyMeterApi;
  public production = BaseUrlConstantsService.PRODUCTION_KEY;
  public deviceId: any;
  public assetId: any;
  public userID: any;
  public clientName: any;
  public siteName: any;
  public applicationName: any;
  public serialNo:any;
  public centralLabel = "";
  public canvasWidth = 160;
  public gaugeShow: boolean=false;
  public dataGadge: any;
  public Itemsymbol: any;
  public APIUrl="";
  public tabName = 'tab-3';
  public device_status: any;
  public connection_status: any;
  public breadcrumbsArray: any = [
    {
      page_ref: "device-reports",
      page_title: "All Meters",
    },
  ];
  //myparameter static;
  public role: string;
  public subsystem_id:string;
  public ofs:string|boolean |number;
  public ofsSubscription;

  tab1: string
  tab2: string
  tab4: string


  openAlertModal: boolean=false;
  alertSettings: any=[];
  alertsLoader: boolean=true;
  hasConfiguredAlerts: boolean=false;
  alertsRoleId=2;//2 is for user 3 is for client;
  alertsSaveLoader: boolean;
  generic_asset_id: any;

  constructor(

    public service: BackendApiService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    public router: Router, 
    public activeRoute: ActivatedRoute,
    public meterSrv:EnergyMeterService,
    private cdRef: ChangeDetectorRef,
    private zone: NgZone

  ) { 
    this.generic_asset_id =localStorage.getItem('generic_asset_id');
      if(localStorage.getItem('role') === 'CLIENT'){
        this.userID = localStorage.getItem('user_id');
        this.assetId =localStorage.getItem('assetId');
        this.clientName = localStorage.getItem('company_name');
        // this.siteName=localStorage.getItem('SiteName');
        // this.applicationName = localStorage.getItem('ApplicationName');
      }else if(localStorage.getItem('role') === 'ADMIN'){
        if(localStorage.getItem('admin_client_id') !== '' && localStorage.getItem('admin_client_id') !== undefined && localStorage.getItem('admin_client_id') !== null && parseInt(localStorage.getItem('admin_client_id')) > 0 ){
          this.userID = localStorage.getItem('admin_client_id');
          this.clientName = localStorage.getItem('company_name');
          // this.siteName=localStorage.getItem('SiteName');
          //  this.applicationName = localStorage.getItem('ApplicationName');
        }
      }

      this.serialNo=localStorage.getItem('serial_number');

      

      
      this.role = localStorage.getItem('role');
      activeRoute.queryParams.subscribe((params) => {
        console.log(params,'paramssssssssssss');
        if(localStorage.getItem('role') === 'USER'){
         this.userID = localStorage.getItem('associated_clientid');
       }
       this.device_status = params['device_status'];
       this.connection_status = params['connection_status']
       this.subsystem_id = params['subsystem_id']
       this.tab1 = params['tab1']
       this.tab2 = params['tab2']
       this.tab4 = params['tab4']
       this.ofs=params['ofs'];
     })
      this.getEnergymeterDatetime(this.userID,this.generic_asset_id);

     

      this.utcTime()
    }
 
  async ngOnInit() {  
    this.generic_asset_id = localStorage.getItem('generic_asset_id');

    // await Promise.all([
    this.PhaseLoadCurrent()
    this.PeakDemandKWKVA()
    this.getHeadingData()
    this.PhaseLineVoltage()
    this.TotalHarmonicDistortion()
    this.PowerFactorFrequency()
    this.CumulativeEnergyKWH()
    this.fetchAlertSettings()
    this.voltageGauge()
    this.currentGauge();
    this.peakDemandGauge();
    this.PFGauge();
    this.THDGauge();
    this.cumulativeGauge();
    // ])
    this.meterSrv.setMeterData({client_id:this.userID, generic_asset_id:this.generic_asset_id,subsystem_id:this.subsystem_id,ofs:this.ofs});
    this.ofsSubscription=this.meterSrv.meterSrvDataObs.subscribe(data=>{
      if(data.ofs != undefined)this.ofs=data.ofs==false?0:1
    })

  }
  async goToPageLink(name: string) {
    let user=localStorage.getItem('role')
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        tabName : this.tabName,
        tab1:this.tab1,
        tab3:true,
        tab2:this.tab2,
        tab4:this.tab4,
        clientName:localStorage.getItem('company_name'),
        pageRef:user=='ADMIN'?"admin-emeter":"client-emeter"
      },
    };
    this.router.navigate([user=='ADMIN'?'device-report-new':'device-reports'], navigationExtras);
  }
  
  utcTime() {
    setInterval(() => {
      const date = new Date().getHours();
      const houre = new Date().getMinutes();
      const second = new Date().getSeconds();
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
   //For DSP 
  //  this.today=new Date();
      const time = date + ':' + houre + ':' + second;
      // this.myDate = JSON.parse(JSON.stringify(time));
    }, 1000);
  }


  getEnergymeterDatetime(userId,generic_asset_id){
    console.log()
    this.service.getDataWithQuery(this.emeterData+"/get-energymeter-datetime/"+userId+"/"+generic_asset_id).then((res) => {

      let response = JSON.parse(JSON.stringify(res)).data;

      if (response.status === "fail") {
        const msgErr = response.body.message;
        this.service.showError(msgErr);
      } else if (response.status === "success") {

        //this.today
        if(response.body[0].created_at != ""){
          // console.log("CREATED AT: " + response.body[0].created_at)
          let testDateUtc = moment.utc(
            response.body[0].created_at
          );
          // this.emLastDataTime = new ConvertDatetimePipe().convertDateTime(response.body[0].created_at.toString());
          this.emLastDataTime = new ConvertDatetimePipe().convertDateTime(testDateUtc);
          
          
        }
      }

    });
    
  }


  openEmeterGraphSettingsDialog(metric_type: string, generic_asset_id: any): void {
    // Open Dialog Box with loading state
   
    const dialogRef = this.dialog.open(DialogGraphscaleSettingsComponent, {
      width: '800px',
      data: { loading: true } // Initial data with loading state
    });
  
    // Fetch data
    this.getEmeterGraphScaleSettingsDataByID(metric_type, generic_asset_id).then((data: any) => {
      // Prepare the data
      const response = data;
      // const graphScaleSettingData = {
      //   metric_type: metric_type,
      //   id: thresholdID,
      //   green: response.threshold_1,
      //   yellow: response.threshold_2,
      //   red: response.threshold_3,
      //   max_value: response.max_value,
      //   min_value: response.base_value
      // };
  
      // Update dialog data
      dialogRef.componentInstance.updateData(response);
    }).catch(error => {
      console.error('Error fetching data:', error);
      // Handle error here
    });
  
    // Handle dialog close event
    dialogRef.afterClosed().subscribe(async updatedSettings => {
      if (updatedSettings) {

        const isSuccess=await this.saveSettings(updatedSettings);  
        console.log(isSuccess,'isSuccess');
        var currentSettingRequest = updatedSettings[0].metric_type;
        console.log(currentSettingRequest,'curent')
        if (currentSettingRequest === '3PhaseLoadCurrentA') {
          this.threephaseloadcurrentloading = true;
          this.trendscurrentloading = true;
          setTimeout(() => {
           this.currentGauge();
           this.PhaseLoadCurrent();
          }, 2000);
        }  
        if (currentSettingRequest === '3PhaseLineVoltageA') {
          this.threephaselinevoltageloading = true;
          this.trendsvoltageloading = true;
          setTimeout(() => {
            this.PhaseLineVoltage();
          }, 2000);
        }
        if (currentSettingRequest === 'TotalHarmonicDistortionA') {
          this.totalharmonicdistortionloading = true;
          this.trendshtdloading = true;
          setTimeout(() => {
            this.THDGauge();
            this.TotalHarmonicDistortion();
          }, 2000);
        }
        if (currentSettingRequest === 'CumulativeEnergyA' && isSuccess) {
          setTimeout(() => {
            this.cumulativeGauge();
            this.CumulativeEnergyKWH();
          }, 2000);
        }
        if (currentSettingRequest === 'CumulativeEnergyA') {
          this.cumulativeenergyloading = true;
          this.trendsCumulativeEnergyloading = true;
        }
        if (currentSettingRequest === 'PowerFactor') {
          this.powerfactorloading = true;
          this.trendspowerfactorloading = true;
          this.trendsfrequencyloading = true;
          setTimeout(() => {
            this.PFGauge();
            this.PowerFactorFrequency();
          }, 0);
        }
        
        if (currentSettingRequest === 'PeakDemand-KW') {
          this.peakdemandloading = true;
          this.trendskwdemandloading = true;
          setTimeout(() => {
            this.PeakDemandKWKVA();
          }, 2000);
        }
        
  
        // Show toast message
        this._snackBar.open('Settings have been saved successfully.', 'Dismiss', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'center' as MatSnackBarVerticalPosition, // Explicitly specify the type
          panelClass: ['custom-snackbar']
        });
      }
    });
  }
  
  openEmeterGraphVpfSettingsDialog(metric_type: string, generic_asset_id: any): void {
    // Open Dialog Box with loading state
    const dialogRef = this.dialog.open(DialogGraphscaleVpfSettingsComponent, {
      width: '1050px',
      data: { loading: true } // Initial data with loading state
    });
   
    // Fetch data
    this.getEmeterVpfGraphScaleSettingsDataByID(metric_type, generic_asset_id).then((data: any) => {
      // Prepare the data
      const response = data;
      // Update dialog data
      // console.log(response);
      
      dialogRef.componentInstance.updateData(response);
    }).catch(error => {
      console.error('Error fetching data:', error);
      // Handle error here
    });
  
    // Handle dialog close event
    dialogRef.afterClosed().subscribe(updatedSettings => {
      // console.log(updatedSettings)
      if (updatedSettings) {
// console.log("==================")
        this.saveVpfSettings(updatedSettings);  
       
        var currentSettingRequest = updatedSettings[0].metric_type;
        // console.log("saving done", currentSettingRequest)
         console.log(currentSettingRequest,'currentSettingRequest')
       
        if (currentSettingRequest === '3PhaseLineVoltageA') {
          let {base_value,orieX_default,orieY_default,orieZ_default,threshold_1,threshold_2,threshold_3,max_value}=updatedSettings[0]
          this.voltageStripLines=[base_value,threshold_1,threshold_2,orieX_default,orieY_default,max_value]
          this.threephaselinevoltageloading = true;
          this.trendsvoltageloading = true;
          setTimeout(() => {
            this.voltageGauge();
            this.PhaseLineVoltage();
          }, 2000);
        }
      
        if (currentSettingRequest === 'PowerFactor') {
          let {base_value,orieX_default,orieY_default,orieZ_default,threshold_1,threshold_2,threshold_3,max_value}=updatedSettings[0]
          this.powerFactorStripLines=[base_value,threshold_1,threshold_2,threshold_3,orieY_default,max_value]
          this.powerfactorloading = true;
          this.trendspowerfactorloading = true;
          this.trendsfrequencyloading = true;
          setTimeout(() => {
            this.PFGauge();
            this.PowerFactorFrequency();
          }, 2000);
        }
        // if (currentSettingRequest === 'Frequency') {
        //   console.log('Setting')
        //   let {base_value,orieX_default,orieY_default,orieZ_default,threshold_1,threshold_2,threshold_3,max_value}=updatedSettings[1]
        //   this.frequencyStripLines=[base_value,threshold_1,threshold_2,orieX_default,orieY_default,max_value]
        //   this.powerfactorloading = true;
        //   console.log("+++++++++++++++++")
        //   this.trendspowerfactorloading = true;
        //   this.trendsfrequencyloading = true;
        //   setTimeout(() => {
        //     this.PowerFactorFrequency();
        //   }, 0);
        // }
        if (currentSettingRequest === 'PeakDemand-KVA') {
          let {base_value,orieX_default,orieY_default,orieZ_default,threshold_1,threshold_2,threshold_3,max_value}=updatedSettings[1]
          // this.kwStripLines=[base_value,threshold_1,threshold_2,orieX_default,orieY_default,max_value]
          this.peakdemandloading = true;
          this.trendskwdemandloading = true;
          setTimeout(() => {
            this.peakDemandGauge();
            this.PeakDemandKWKVA();
          }, 2000);
        }
        // Show toast message
        this._snackBar.open('Settings have been saved successfully.', 'Dismiss', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'center' as MatSnackBarVerticalPosition, // Explicitly specify the type
          panelClass: ['custom-snackbar']
        });
      }
    });
  }

  async saveSettings(updatedSettings: any):Promise<boolean> {
    // Implement saving logic using DataService
    // Example:
    return await this.service.saveSettings(this.emeterData+"/emeter-graph-scale-settings-save?generic_asset_id="+this.generic_asset_id,updatedSettings).then((sRes) => {
    // return await this.service.saveSettings("http://localhost:3105/emeter/emeter-graph-scale-settings-save?serialNo="+this.serialNo,updatedSettings).then((sRes) => {
      return true;
    }, error => {
      console.error('Error saving settings:', error);
      return false;
    }).catch(()=>{return false});
  }

  saveVpfSettings(updatedSettings: any): void {

    // Implement saving logic using DataService
    // Example:
    this.service.saveSettings(this.emeterData+"/emeter-graph-scale-vpf-settings-save/"+this.generic_asset_id,updatedSettings).then((sRes) => {
      console.log(sRes,'ressssssssssssssssss');
      
    }, error => {
      console.error('Error saving settings:', error);
    });
  }
  //Graph Scale Setting Dialog Box Code End.

  public async getHeadingData(){
    this.service.getDataWithQuery(this.emeterData +"/get-heading-data/"+this.subsystem_id).then((dRes) => {

      let response = JSON.parse(JSON.stringify(dRes)).data;   
      // console.log(response)
      this.siteName = response.site_name;
      this.applicationName = response.application_name;
      this.deviceMaker = response.device_maker;
      this.serialNo = response.serial_number;
      // this.generic_asset_id = response.generic_asset_id;
    })
    // console.log(this.emeterData +"/get-heading-data/"+this.serialNo)
  }

  public async PhaseLoadCurrent(){
    console.time('start');


      //Enerty Meter:: Line Graph :: Current.      
       this.service.getDataWithQuery(this.emeterData+'/trends-current/'+this.userID+"/"+this.generic_asset_id+"/hour").then((sRes) => {
        
        let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

          let response = sensorRes.body;
          this.emCurrentLineData =[];
          this.CurrentLineChartColors =[];

          this.CurrentLineChartOptions = response.name;
          this.emCurrentLineUnit = response.symbol;

            if (response.sensor != undefined){

              if(response.sensor.length != 0){
                let barData= response.sensor;
                this.emCurrentLineData.push(barData);              
              }

              if(response.rangeLabels.length != 0){              
                this.CurrentLineChartColors.push(response.rangeLabels);
              }
              
              if(this.CurrentLineChartColors.length >=1 || this.emCurrentLineData.length >=1){                  
                setTimeout(() => {
                  this.trendscurrentloading=false;
                }, 1000);
              }        

            }

            if(response.movingAvg != undefined){

              if(response.movingAvg.length != 0){

                  this.emCurrentLineMovingAvg = response.movingAvg;
                  this.emCurrentLineMovingCount = response.movingCount;
              }
            }
        }

      });

  }
  currentGauge(){
      //Enerty Meter:: Gauge Graph :: 3 Phase Load Current.
      this.service.getDataWithQuery(this.emeterData +"/3phase-load-current/"+this.userID+"/"+this.generic_asset_id).then((sRes) => {

        let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
      
        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
        
          let response = sensorRes.body;
          //this.threePhaseLoadCurrentSettingID = response.thresholdsID;
          this.em3PhaseLoadCurrentData =[];
          if (response.sensor != undefined){
            if(response.sensor.length != 0){

              this.dataGadge= response.sensor;

              if (this.dataGadge.length !== 0) {

                let tempArr = [];
                let bottomLab = "";
              
                for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
              
                  if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {

                      bottomLab = "0";
                  } else {
                    bottomLab =JSON.parse(this.dataGadge[mCount].value) <= 0 ? "0 A": this.dataGadge[mCount].symbol === "C" ? JSON.parse(this.dataGadge[mCount].value).toFixed(2) +
                          " °" + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value).toFixed(2) +" " +this.dataGadge[mCount].icon;
                  }

                  this.Itemsymbol = this.dataGadge[mCount].symbol;
                  let needleValueRes;
                  if (this.dataGadge[mCount].symbol === "m/sec²") {
                    needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                  } else if (this.dataGadge[mCount].symbol === "mm/sec") {
                    needleValueRes = (JSON.parse(this.dataGadge[mCount].value));
                  } else if (this.dataGadge[mCount].symbol === "deg") {
                    needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                  } else {
                    //needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                    needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                  }

                  let centerLab = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);
                  let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors: ["transparent", "transparent", "transparent"];
                  let range_label =this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel: [];
                  let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters: [];
                  let value = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value).toFixed(2);

                  const em3PhaseLoadCurrentAccelerationData = {
                    value:value,
                    needleValue: needleValueRes,
                    centralLabel: centerLab,
                    outerNeedle: false,
                    canvasWidth: 150,                                                                                                                                                                                                                                         
                    name: this.dataGadge[mCount].name,
                    key: this.dataGadge[mCount].key,
                    bottomLabel: bottomLab,
                    hasneedle: this.dataGadge[mCount].needle,
                    options: {
                      hasNeedle: this.dataGadge[mCount].needle,
                      needleColor: "black",
                      needleUpdateSpeed: "",
                      arcColors: arc_colors,
                      arcLabels: [] as string[],
                      arcDelimiters: this.dataGadge[mCount].arcDelimiters,
                      rangeLabel: range_label,
                      needleStartValue: 0,
                    },
                  };
                  

                  if (arc_Delimiters[0] < 100 && arc_Delimiters[0] > 0 && arc_Delimiters[1] > 0 && arc_Delimiters[0] < arc_Delimiters[1] && arc_Delimiters[1] < 100) {

                    let max = range_label[1] != null ? range_label[1] : 0;
                    // em3PhaseLoadCurrentAccelerationData.options.arcLabels[0] = sensorRes.body.rangeLabels.green;                    
                    // em3PhaseLoadCurrentAccelerationData.options.arcLabels[1] = sensorRes.body.rangeLabels.yellow;
                    // let velocityG = sensorRes.body.rangeLabels.green;
                    // let velocityY = sensorRes.body.rangeLabels.yellow;
                    // let velocityR = max;

                    em3PhaseLoadCurrentAccelerationData.options.arcLabels[0] = ((max * this.dataGadge[mCount].arcDelimiters[0]) / 100).toFixed(1).toString();
                    em3PhaseLoadCurrentAccelerationData.options.arcLabels[1] = ((max * this.dataGadge[mCount].arcDelimiters[1]) / 100).toFixed(1).toString();
                    //let velocityG = this.dataGadge[mCount].arcDelimiters[0];
                    //let velocityY = this.dataGadge[mCount].arcDelimiters[1];
                    //let velocityR = max;

                    em3PhaseLoadCurrentAccelerationData.options.arcColors[0] = "#72FF13";
                    em3PhaseLoadCurrentAccelerationData.options.arcColors[1] = "#FAA700";
                    em3PhaseLoadCurrentAccelerationData.options.arcColors[2] = "#ff2a1b";
        
                    if (
                      em3PhaseLoadCurrentAccelerationData.centralLabel <= em3PhaseLoadCurrentAccelerationData.options.arcLabels[0]
                    ) {
                      // accelerationData.options.centralLabel=
                      em3PhaseLoadCurrentAccelerationData.options.needleColor = "#72FF13";
                    } else if (
                      em3PhaseLoadCurrentAccelerationData.centralLabel > em3PhaseLoadCurrentAccelerationData.options.arcLabels[0] &&
                      em3PhaseLoadCurrentAccelerationData.centralLabel <= em3PhaseLoadCurrentAccelerationData.options.arcLabels[1]
                    ) {
                      em3PhaseLoadCurrentAccelerationData.options.needleColor = "#FAA700";
                    } else {
                      em3PhaseLoadCurrentAccelerationData.options.needleColor = "#ff2a1b";
                    }
        
                    this.em3PhaseLoadCurrentData.push(em3PhaseLoadCurrentAccelerationData);
                    // console.log(this.em3PhaseLoadCurrentData[0])
                    this.gaugeShow=true;
                  }

                  if(this.em3PhaseLoadCurrentData.length >=1){                  
                    setTimeout(() => {
                      console.timeEnd('start')
                      this.threephaseloadcurrentloading=false;
                    }, 1000);
                  }

                 
                
                }
                
              }

            }
                
          }

          if (response.balancing != undefined){

            if(response.balancing.length != 0){
              
              this.BalancingDataGadge= response.balancing;
          
              if (this.BalancingDataGadge.length !== 0) {
                let tempArr = [];
                let bottomLab = "";
                let v1 =0;
                let v2 =0;
                let v3 =0;
                let maxValue:any=0;

                let greenRange = 0;
                let yellowRange = 0;
                let redRange = 0;
                
                              
                /******************* Load Balancing Code Start Here *****************/

                if(this.em3PhaseLoadCurrentData[0].value > 0){}else{this.em3PhaseLoadCurrentData[0].value=0.00;}
                  if(this.em3PhaseLoadCurrentData[1].value > 0){}else{this.em3PhaseLoadCurrentData[1].value=0.00;}
                  if(this.em3PhaseLoadCurrentData[2].value > 0){}else{this.em3PhaseLoadCurrentData[2].value=0.00;}

                  let Total:number = parseFloat(this.em3PhaseLoadCurrentData[0].value) + parseFloat(this.em3PhaseLoadCurrentData[1].value) + parseFloat(this.em3PhaseLoadCurrentData[2].value);

                  this.em3PhaseLoadCurrentAvg = Total/3;
                  if(this.BalancingDataGadge[0].threshold_1 >0 && this.BalancingDataGadge[0].threshold_2 >0 && this.BalancingDataGadge[0].threshold_3 >0 && this.BalancingDataGadge[0].max_value >0 ){
          
                    v1=this.em3PhaseLoadCurrentData[0].value-this.em3PhaseLoadCurrentAvg;
                    v2=this.em3PhaseLoadCurrentData[1].value-this.em3PhaseLoadCurrentAvg;
                    v3=this.em3PhaseLoadCurrentData[2].value-this.em3PhaseLoadCurrentAvg;
                                                                                                                                                                                                                                                              maxValue = Math.max(v1, v2, v3);
                    
                    this.em3PhaseLoadCurrentAvg=(maxValue*100)/this.em3PhaseLoadCurrentAvg;  
                    this.em3PhaseLoadCurrentAvgPer=this.em3PhaseLoadCurrentAvg;
                    this.em3PhaseLoadCurrentAvg = (this.em3PhaseLoadCurrentAvg*100)/this.BalancingDataGadge[0].max_value;

                    this.em3PhaseLoadCurrentGreenBar=this.BalancingDataGadge[0].threshold_1;
                    this.em3PhaseLoadCurrentYellowBar=this.BalancingDataGadge[0].threshold_2;
                    this.em3PhaseLoadCurrentRedBar = (100-(this.BalancingDataGadge[0].threshold_2+this.BalancingDataGadge[0].threshold_1));
                    
                    this.em3PhaseLoadCurrentGreenText=(this.BalancingDataGadge[0].threshold_1*this.BalancingDataGadge[0].max_value)/100;
                    this.em3PhaseLoadCurrentYellowText=((this.BalancingDataGadge[0].threshold_2+this.BalancingDataGadge[0].threshold_1)*this.BalancingDataGadge[0].max_value)/100;
                    this.em3PhaseLoadCurrentRedText = ((this.BalancingDataGadge[0].threshold_3+this.BalancingDataGadge[0].threshold_2+this.BalancingDataGadge[0].threshold_1)*this.BalancingDataGadge[0].max_value)/100;


                    greenRange = this.BalancingDataGadge[0].threshold_1;
                    yellowRange = this.BalancingDataGadge[0].threshold_1+this.BalancingDataGadge[0].threshold_2;
                    redRange = this.BalancingDataGadge[0].threshold_1+this.BalancingDataGadge[0].threshold_2+this.BalancingDataGadge[0].threshold_3;

                    if(this.em3PhaseLoadCurrentAvg > 0 && this.em3PhaseLoadCurrentAvg <= greenRange){
          
                      this.em3PhaseLoadCurrentCol = 'green';
                      this.em3PhaseLoadCurrentAvg = ((this.em3PhaseLoadCurrentAvg*100)/this.BalancingDataGadge[0].threshold_1).toFixed(2);
          
                    }else if(this.em3PhaseLoadCurrentAvg >= greenRange && this.em3PhaseLoadCurrentAvg <= yellowRange){
          
                      this.em3PhaseLoadCurrentCol = 'yellow';
                      this.em3PhaseLoadCurrentAvg =  this.em3PhaseLoadCurrentAvg-this.BalancingDataGadge[0].threshold_1;
                      this.em3PhaseLoadCurrentAvg =  (this.em3PhaseLoadCurrentAvg*100)/this.BalancingDataGadge[0].threshold_2; 
                    }else if(this.em3PhaseLoadCurrentAvg >= greenRange && this.em3PhaseLoadCurrentAvg <= redRange){
          
                      this.em3PhaseLoadCurrentCol = 'red';                    
                      this.em3PhaseLoadCurrentAvg = this.em3PhaseLoadCurrentAvg-yellowRange;
                      this.em3PhaseLoadCurrentAvg = (this.em3PhaseLoadCurrentAvg*100)/this.BalancingDataGadge[0].threshold_3;
                     
                    }else{
                      if(this.em3PhaseLoadCurrentAvg > 0){
                        
                        this.em3PhaseLoadCurrentCol = 'red';                        
                        this.em3PhaseLoadCurrentAvg='100';

                      }else{

                        this.em3PhaseLoadCurrentCol = '';

                      }
                      
                    }
          
                  }else{
                    this.em3PhaseLoadCurrentCol = ''; 
                  }
                /******************* Ooad Balancing Code End Here *******************/
          
          
              }
              
            }
          }

        }

      })
  }

  public async PhaseLineVoltage(){
    console.log(this.generic_asset_id)

      //Enerty Meter:: Line Graph :: voltage.      
       this.service.getDataWithQuery(this.emeterData+'/trends-voltage/'+this.userID+"/"+this.generic_asset_id+"/hour").then((sRes) => {
        
        let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

          let response = sensorRes.body;
          // console.log(response)
          this.emVoltageLineData =[];
          this.VoltageLineChartColors =[];

          this.VoltageLineChartOptions = response.name;
          this.emVoltageLineUnit = response.symbol;

            if (response.sensor != undefined){

              if(response.sensor.length != 0){
                let barData= response.sensor;
                this.emVoltageLineData.push(barData);              
              }

              if(response.rangeLabels.length != 0){              
                this.VoltageLineChartColors.push(response.rangeLabels);
              }
              
              if(this.emVoltageLineData.length >=1 || this.VoltageLineChartColors.length >=1){                  
                // setTimeout(() => {
                  this.trendsvoltageloading=false;
                // }, 1000);
              }
              if(response.rangeLabels){
                let {min_value,max_value,threshold_1,threshold_2,orieX_default,orieY_default} = response.rangeLabels
                // let arcs=em3PhaseLineVoltageAccelerationData.options.arcLabels;
                // let range=em3PhaseLineVoltageAccelerationData.options.rangeLabel;
                this.voltageStripLines=[];
                // this.voltageStripLines.push(Number(range[0]))
                // this.voltageStripLines.push(Number(arcs[0]))
                // this.voltageStripLines.push(Number(arcs[1]))
                // this.voltageStripLines.push(Number(arcs[2]))
                // this.voltageStripLines.push(Number(arcs[3]))
                // this.voltageStripLines.push(Number(arcs[4]))
                // this.voltageStripLines.push(Number(arcs[5]))
                // this.voltageStripLines.push(Number(range[1]))
                this.voltageStripLines.push(min_value,threshold_1,threshold_2,orieX_default,orieY_default,max_value)
            }
            }

            if(response.movingAvg != undefined){

              if(response.movingAvg.length != 0){

                  this.emVoltageLineMovingAvg = response.movingAvg;
                  this.emVoltageLineMovingCount = response.movingCount;
              }
            }


        }

      });
    //   let graphInterval2=setInterval(()=>{
    //     if((this.emVoltageLineData.length >=1 || this.VoltageLineChartColors.length >=1) && this.em3PhaseLineVoltageData.length >=1){                  
    //       this.trendsvoltageloading=false;
    //       this.threephaselinevoltageloading=false;
    //       clearInterval(graphInterval2)
    //   }
    // },2000)
  }

  voltageGauge(){
          //Enerty Meter:: Gauge Graph :: 3 Phase Line Voltage.
          this.service.getDataWithQuery(this.emeterData +"/3phase-line-voltage/"+this.userID+"/"+this.generic_asset_id).then((sRes) => {

            let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
          
            if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
            
              let response = sensorRes.body;
              //this.threePhaseLineVoltageSettingID = response.thresholdsID;
              this.em3PhaseLineVoltageData =[];
              if (response.sensor != undefined){
                if(response.sensor.length != 0){
    
                  this.dataGadge= response.sensor;
    
                  if (this.dataGadge.length !== 0) {
                    let tempArr = [];
                    let bottomLab = "";
                  
                    for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
                  
                      if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {
    
                          bottomLab = "N/A";
                      } else {
                        bottomLab =JSON.parse(this.dataGadge[mCount].value) <= 0 ? "N/A": this.dataGadge[mCount].symbol === "C" ? JSON.parse(this.dataGadge[mCount].value).toFixed(2)+
                              " °" + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value).toFixed(2) +" " +this.dataGadge[mCount].icon;
                      }
    
                      this.Itemsymbol = this.dataGadge[mCount].symbol;
                      let centerLab = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);
                      let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors: ["transparent", "transparent", "transparent"];
                      let range_label =this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel: [];
                      let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters: [];
                      let value = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value).toFixed(2);
    
                      /***********my new logic start for new gauge chart for PF***********/                  
                      let RedUnderVal=0;
                      let yellowUnderVal=0;
                      let GreenUnderVal=0;
                      let greenOverVal=0;
                      let yellowOverVal=0;
                      let rangeDiffrence=0;                                   
    
                      if(range_label.length === 2){                  
                        
                        RedUnderVal =  parseFloat(arc_Delimiters[0]);
                        yellowUnderVal =  parseFloat(arc_Delimiters[1]);
                        GreenUnderVal = parseFloat(arc_Delimiters[2]);
                        greenOverVal =  parseFloat(arc_Delimiters[3]);
                        yellowOverVal =  parseFloat(arc_Delimiters[4]);
                        rangeDiffrence = (parseFloat(range_label[1])-parseFloat(range_label[0]));
                       
                      }
                      
                      let arc_Delimiters_values =[];
    
                      //1st value. 
                      let FirstVal = 0;
                      FirstVal = (RedUnderVal-parseFloat(range_label[0])); 
                      FirstVal = ((FirstVal*100)/rangeDiffrence);           
                      arc_Delimiters_values.push(FirstVal);
    
                      //2nd value.                   
                      let SecondsVal = 0;
                      SecondsVal = (yellowUnderVal-parseFloat(range_label[0])); 
                      SecondsVal = ((SecondsVal*100)/rangeDiffrence);           
                      arc_Delimiters_values.push(SecondsVal);
    
                      //3rd value.
                      let thirdVal = 0;
                      thirdVal = (GreenUnderVal-parseFloat(range_label[0])); 
                      thirdVal = ((thirdVal*100)/rangeDiffrence);           
                      arc_Delimiters_values.push(thirdVal);
    
                      //4th value. 
                      let FourthVal = 0;
                      FourthVal = (greenOverVal-parseFloat(range_label[0])); 
                      FourthVal = ((FourthVal*100)/rangeDiffrence);           
                      arc_Delimiters_values.push(FourthVal);
    
                      //5th value. 
                      let FifthVal = 0;
                      FifthVal = (yellowOverVal-parseFloat(range_label[0])); 
                      FifthVal = ((FifthVal*100)/rangeDiffrence);           
                      arc_Delimiters_values.push(FifthVal);
                      
    
                      let needleVal = 0;
                      let needleMinPercentage = 0;
                      let needleMinValue = 0;
                      let needleMaxPercentage = 0;                  
                      let needleMaxValue = 0;
                      let percentage = 0;
    
                      needleVal = this.dataGadge[mCount].value;
    
                      
                      //Update needleValueRes.
                      if(this.dataGadge[mCount].value <=RedUnderVal){
    
                        needleMinValue = 0;
                        needleMaxValue = RedUnderVal;
                        needleMinPercentage = 0;
                        needleMaxPercentage = arc_Delimiters_values[0];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
    
                      }else if(needleVal >= RedUnderVal && needleVal <= yellowUnderVal){
    
                        needleMinValue = RedUnderVal;
                        needleMaxValue = yellowUnderVal;
                        needleMinPercentage = arc_Delimiters_values[0];
                        needleMaxPercentage = arc_Delimiters_values[1];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
                        
                      }else if(needleVal >= yellowUnderVal && needleVal <= GreenUnderVal){
    
                        needleMinValue = yellowUnderVal;
                        needleMaxValue = GreenUnderVal;
                        needleMinPercentage = arc_Delimiters_values[1];
                        needleMaxPercentage = arc_Delimiters_values[2];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
    
                      }else if(needleVal >= GreenUnderVal && needleVal <= greenOverVal){
    
                        needleMinValue = GreenUnderVal;
                        needleMaxValue = greenOverVal;
                        needleMinPercentage = arc_Delimiters_values[2];
                        needleMaxPercentage = arc_Delimiters_values[3];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
    
                      }else if(needleVal >= greenOverVal && needleVal <= yellowOverVal){
    
                        needleMinValue = greenOverVal;
                        needleMaxValue = yellowOverVal;
                        needleMinPercentage = arc_Delimiters_values[3];
                        needleMaxPercentage = arc_Delimiters_values[4];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
    
                      }else{
    
                        needleMinValue = yellowOverVal;
                        needleMaxValue = range_label[1];
                        needleMinPercentage = arc_Delimiters_values[4];
                        needleMaxPercentage = arc_Delimiters_values[5];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
    
                      }
    
                      /***********my new logic end here for new gauge chart for PF***********/
    
    
    
                      const em3PhaseLineVoltageAccelerationData = {
                        value:value,
                        needleValue: needleVal,
                        centralLabel: centerLab,
                        outerNeedle: false,
                        canvasWidth: 150,
                        name: this.dataGadge[mCount].name,
                        key: this.dataGadge[mCount].key,
                        bottomLabel: bottomLab,
                        hasneedle: this.dataGadge[mCount].needle,
                        options: {
                          hasNeedle: this.dataGadge[mCount].needle,
                          needleColor: "black",
                          needleUpdateSpeed: "",
                          arcColors: arc_colors,
                          arcLabels: [] as string[],
                          arcDelimiters: arc_Delimiters_values,
                          rangeLabel: range_label,
                          needleStartValue: 0,
                        },
                      };
    
                      if (arc_Delimiters_values[0] < 100 && arc_Delimiters_values[0] > 0 && arc_Delimiters_values[1] > 0 && arc_Delimiters_values[0] < arc_Delimiters_values[1] && arc_Delimiters_values[1] < 100) {
                        
                        
                        
                        //*******************************************************************************
                        let max = range_label[1] != null ? range_label[1] : 0;
                                           
                        em3PhaseLineVoltageAccelerationData.options.arcLabels[0] = (RedUnderVal).toFixed(0).toString();
                        em3PhaseLineVoltageAccelerationData.options.arcLabels[1] = (yellowUnderVal).toFixed(1).toString();
                        em3PhaseLineVoltageAccelerationData.options.arcLabels[2] = (GreenUnderVal).toFixed(1).toString();
                        em3PhaseLineVoltageAccelerationData.options.arcLabels[3] = (greenOverVal).toFixed(1).toString();
                        em3PhaseLineVoltageAccelerationData.options.arcLabels[4] = (yellowOverVal).toFixed(1).toString();
                       
                        em3PhaseLineVoltageAccelerationData.options.arcColors[0] = "#ff2a1b";
                        em3PhaseLineVoltageAccelerationData.options.arcColors[1] = "#FAA700";
                        em3PhaseLineVoltageAccelerationData.options.arcColors[2] = "#72FF13";
                        em3PhaseLineVoltageAccelerationData.options.arcColors[3] = "#72FF13";
                        em3PhaseLineVoltageAccelerationData.options.arcColors[4] = "#FAA700";
                        em3PhaseLineVoltageAccelerationData.options.arcColors[5] = "#ff2a1b";
            
                        if (
                          em3PhaseLineVoltageAccelerationData.centralLabel <= em3PhaseLineVoltageAccelerationData.options.arcLabels[0]
                        ) {
                          // accelerationData.options.centralLabel=
                          em3PhaseLineVoltageAccelerationData.options.needleColor = "#ff2a1b";
                        } else if (
                          em3PhaseLineVoltageAccelerationData.centralLabel > em3PhaseLineVoltageAccelerationData.options.arcLabels[0] &&
                          em3PhaseLineVoltageAccelerationData.centralLabel <= em3PhaseLineVoltageAccelerationData.options.arcLabels[1]
                        ) {
                          em3PhaseLineVoltageAccelerationData.options.needleColor = "#FAA700";
                        } else if (
                          em3PhaseLineVoltageAccelerationData.centralLabel > em3PhaseLineVoltageAccelerationData.options.arcLabels[1] &&
                          em3PhaseLineVoltageAccelerationData.centralLabel <= em3PhaseLineVoltageAccelerationData.options.arcLabels[2]
                        ){
    
                          em3PhaseLineVoltageAccelerationData.options.needleColor = "#72FF13";
                        }else if (
                          em3PhaseLineVoltageAccelerationData.centralLabel > em3PhaseLineVoltageAccelerationData.options.arcLabels[2] &&
                          em3PhaseLineVoltageAccelerationData.centralLabel <= em3PhaseLineVoltageAccelerationData.options.arcLabels[3]
                        ){
                          em3PhaseLineVoltageAccelerationData.options.needleColor = "#72FF13";
                        }else if (
                          em3PhaseLineVoltageAccelerationData.centralLabel > em3PhaseLineVoltageAccelerationData.options.arcLabels[3] &&
                          em3PhaseLineVoltageAccelerationData.centralLabel <= em3PhaseLineVoltageAccelerationData.options.arcLabels[4]
                        ){
                          em3PhaseLineVoltageAccelerationData.options.needleColor = "#FAA700";
                        }else{
                          em3PhaseLineVoltageAccelerationData.options.needleColor = "#ff2a1b";
                        }
                        if(em3PhaseLineVoltageAccelerationData.options.arcLabels.length && em3PhaseLineVoltageAccelerationData.options.rangeLabel.length){
                          let arcs=em3PhaseLineVoltageAccelerationData.options.arcLabels;
                          let range=em3PhaseLineVoltageAccelerationData.options.rangeLabel;
                          this.voltageStripLines=[];
                          this.voltageStripLines.push(Number(range[0]))
                          this.voltageStripLines.push(Number(arcs[0]))
                          this.voltageStripLines.push(Number(arcs[1]))
                          // this.voltageStripLines.push(Number(arcs[2]))
                          this.voltageStripLines.push(Number(arcs[3]))
                          this.voltageStripLines.push(Number(arcs[4]))
                          // this.voltageStripLines.push(Number(arcs[5]))
                          this.voltageStripLines.push(Number(range[1]))
                          // this.em3PhaseLineVoltageData.voltageStripLines=voltageStripLines
                      }
                        //*******************************************************************************
                                
                        this.em3PhaseLineVoltageData.push(em3PhaseLineVoltageAccelerationData);
                        this.gaugeShow=true;
                      }
                      console.log(this.em3PhaseLineVoltageData,'emem3PhaseLineVoltageDataem3PhaseLineVoltageDataem3PhaseLineVoltageData');
                      if(this.em3PhaseLineVoltageData.length >=1){                  
                        setTimeout(() => {
                        this.threephaselinevoltageloading=false;
                        }, 1000);
                      }
                    
                    }
    
                  }
    
                }
                    
              }
    
              if (response.balancing != undefined){
    
                if(response.balancing.length != 0){
                  
                  this.BalancingDataGadge= response.balancing;
              
                  if (this.BalancingDataGadge.length !== 0) {
                    let tempArr = [];
                    let bottomLab = "";
                    let v1 =0;
                    let v2 =0;
                    let v3 =0;
                    let maxValue:any=0;
    
                    let greenRange = 0;
                    let yellowRange = 0;
                    let redRange = 0;
                    
                                  
                    if(parseFloat(this.em3PhaseLineVoltageData[0].value) > 0 && parseFloat(this.em3PhaseLineVoltageData[1].value) > 0 && parseFloat(this.em3PhaseLineVoltageData[2].value) > 0){
    
                      var Total:number = parseFloat(this.em3PhaseLineVoltageData[0].value) + parseFloat(this.em3PhaseLineVoltageData[1].value) + parseFloat(this.em3PhaseLineVoltageData[2].value);
    
                      this.em3PhaseLineVoltageAvg = Total/3;
    
                      if(this.BalancingDataGadge[0].threshold_1 >0 && this.BalancingDataGadge[0].threshold_2 >0 && this.BalancingDataGadge[0].threshold_3 >0 && this.BalancingDataGadge[0].max_value >0 ){
    
                        if(this.em3PhaseLineVoltageData[0].value > 0){
                          v1=this.em3PhaseLineVoltageData[0].value-this.em3PhaseLineVoltageAvg;
                        }else{
                          v1=0.0;
                        }
                        
                        if(this.em3PhaseLineVoltageData[1].value > 0 ){
                          v2=this.em3PhaseLineVoltageData[1].value-this.em3PhaseLineVoltageAvg;
                        }else{
                          v2=0;
                        }
                        
                        if(this.em3PhaseLineVoltageData[2].value >0){
                          v3=this.em3PhaseLineVoltageData[2].value-this.em3PhaseLineVoltageAvg;
                        }else{
                          v3=0;
                        }
                        
                        maxValue = Math.max(v1, v2, v3);
                        
                        this.em3PhaseLineVoltageAvg=(maxValue*100)/this.em3PhaseLineVoltageAvg;  
                        this.em3PhaseLineVoltageAvgPer=this.em3PhaseLineVoltageAvg;
                        this.em3PhaseLineVoltageAvg = (this.em3PhaseLineVoltageAvg*100)/this.BalancingDataGadge[0].max_value;
    
                        this.em3PhaseLineVoltageGreenBar=this.BalancingDataGadge[0].threshold_1;
                        this.em3PhaseLineVoltageYellowBar=this.BalancingDataGadge[0].threshold_2;
                        this.em3PhaseLineVoltageRedBar = (100-(this.BalancingDataGadge[0].threshold_2+this.BalancingDataGadge[0].threshold_1));
                        
                        this.em3PhaseLineVoltageGreenText=(this.BalancingDataGadge[0].threshold_1*this.BalancingDataGadge[0].max_value)/100;
                        this.em3PhaseLineVoltageYellowText=((this.BalancingDataGadge[0].threshold_2+this.BalancingDataGadge[0].threshold_1)*this.BalancingDataGadge[0].max_value)/100;
                        this.em3PhaseLineVoltageRedText = ((this.BalancingDataGadge[0].threshold_3+this.BalancingDataGadge[0].threshold_2+this.BalancingDataGadge[0].threshold_1)*this.BalancingDataGadge[0].max_value)/100;
    
    
                        greenRange = this.BalancingDataGadge[0].threshold_1;
                        yellowRange = this.BalancingDataGadge[0].threshold_1+this.BalancingDataGadge[0].threshold_2;
                        redRange = this.BalancingDataGadge[0].threshold_1+this.BalancingDataGadge[0].threshold_2+this.BalancingDataGadge[0].threshold_3;
    
                        if(this.em3PhaseLineVoltageAvg > 0 && this.em3PhaseLineVoltageAvg <= greenRange){
    
                          this.em3PhaseLineVoltageCol = 'green';
                          this.em3PhaseLineVoltageAvg = ((this.em3PhaseLineVoltageAvg*100)/this.BalancingDataGadge[0].threshold_1).toFixed(2);
    
                        }else if(this.em3PhaseLineVoltageAvg >= greenRange && this.em3PhaseLineVoltageAvg <= yellowRange){
    
                          this.em3PhaseLineVoltageCol = 'yellow';
                          this.em3PhaseLineVoltageAvg =  this.em3PhaseLineVoltageAvg-this.BalancingDataGadge[0].threshold_1;
                          this.em3PhaseLineVoltageAvg =  (this.em3PhaseLineVoltageAvg*100)/this.BalancingDataGadge[0].threshold_2; 
    
                        }else if(this.em3PhaseLineVoltageAvg >= greenRange && this.em3PhaseLineVoltageAvg <= redRange){
    
                          this.em3PhaseLineVoltageCol = 'red';                    
                          this.em3PhaseLineVoltageAvg = this.em3PhaseLineVoltageAvg-yellowRange;
                          this.em3PhaseLineVoltageAvg = (this.em3PhaseLineVoltageAvg*100)/this.BalancingDataGadge[0].threshold_3;
                          
                        }else{
    
                          if(this.em3PhaseLineVoltageAvg > 0){
                            
                            this.em3PhaseLineVoltageCol = 'red';                        
                            this.em3PhaseLineVoltageAvg='100';
    
                          }else{
    
                            this.em3PhaseLineVoltageCol = '';
    
                          }
                        
                        }
    
                      }
    
                    }else{          
                      this.em3PhaseLineVoltageCol = '';
                    }
              
              
                  }
                  
                }
              }
    
            }
    
          });
  }

  public async TotalHarmonicDistortion(){


      //Enerty Meter:: Line Graph :: KW Demand.    
       this.service.getDataWithQuery(this.emeterData+'/trends-harmonic-distortion/'+this.userID+"/"+this.generic_asset_id+"/hour").then((sRes) => {
        
        let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

          let response = sensorRes.body;
          this.emTHDLineData =[];
          this.THDLineChartColors =[];

          this.THDLineChartOptions = response.name;
          this.emTHDLineUnit = response.symbol;

          if (response.sensor != undefined){

            if(response.sensor.length != 0){
              let barData= response.sensor;
              this.emTHDLineData.push(barData);              
            }

            if(response.rangeLabels.length != 0){              
              this.THDLineChartColors.push(response.rangeLabels);
            }

            if(this.emTHDLineData.length >=1 || this.THDLineChartColors.length >=1){                  
              setTimeout(() => {
                this.trendshtdloading=false;
              }, 1000);
            }      

          }

          if(response.movingAvg != undefined){

            if(response.movingAvg.length != 0){

                this.emTHDLineMovingAvg = response.movingAvg;
                this.emTHDLineMovingCount = response.movingCount;
            }
          }
        }

      });

  }

  THDGauge(){
          //Enerty Meter:: Gauge Graph :: Total Harmonic Distortion.
          this.service.getDataWithQuery(this.emeterData +"/total-harmonic-distortion/"+this.userID+"/"+this.generic_asset_id).then((sRes) => {

            let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
          
            if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
            
              let response = sensorRes.body;
              //this.THDSettingID = response.thresholdsID;
              this.TotalHarmonicDistortionData =[];
              if (response.sensor != undefined){
                if(response.sensor.length != 0){
    
                  this.dataGadge= response.sensor;
    
                  if (this.dataGadge.length !== 0) {
    
                    let tempArr = [];
                    let bottomLab = "";
                  
                    for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
                  
                      if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {
    
                          bottomLab = "N/A";
                      } else {
                        bottomLab =JSON.parse(this.dataGadge[mCount].value) <= 0 ? "N/A": this.dataGadge[mCount].symbol === "C" ? JSON.parse(this.dataGadge[mCount].value).toFixed(2) +
                              " °" + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value).toFixed(2) +" " +this.dataGadge[mCount].icon;
                      }
    
                      this.Itemsymbol = this.dataGadge[mCount].symbol;
                      let needleValueRes;
                      if (this.dataGadge[mCount].symbol === "m/sec²") {
                        needleValueRes = (JSON.parse(this.dataGadge[mCount].value));
                      } else if (this.dataGadge[mCount].symbol === "mm/sec") {
                        needleValueRes = (JSON.parse(this.dataGadge[mCount].value));
                      } else if (this.dataGadge[mCount].symbol === "deg") {
                        needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                      } else {
                        //needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                        needleValueRes = (JSON.parse(this.dataGadge[mCount].value));
                      }
    
                      let centerLab = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);
                      let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors: ["transparent", "transparent", "transparent"];
                      let range_label =this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel: [];
                      let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters: [];
                      let value = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value).toFixed(2);
    
                      const tTotalHarmonicDistortionAccelerationData = {
                        // value:value,
                        needleValue: needleValueRes,
                        centralLabel: centerLab,
                        outerNeedle: false,
                        canvasWidth: 150,
                        name: this.dataGadge[mCount].name,
                        key: this.dataGadge[mCount].key,
                        bottomLabel: bottomLab,
                        hasneedle: this.dataGadge[mCount].needle,
                        options: {
                          hasNeedle: this.dataGadge[mCount].needle,
                          needleColor: "black",
                          needleUpdateSpeed: "",
                          arcColors: arc_colors,
                          arcLabels: [] as string[],
                          arcDelimiters: this.dataGadge[mCount].arcDelimiters,
                          rangeLabel: range_label,
                          needleStartValue: 0,
                        },
                      };
    
                      if (arc_Delimiters[0] < 100 && arc_Delimiters[0] > 0 && arc_Delimiters[1] > 0 && arc_Delimiters[0] < arc_Delimiters[1] && arc_Delimiters[1] < 100) {
    
                        let max = range_label[1] != null ? range_label[1] : 0;
                        // tTotalHarmonicDistortionAccelerationData.options.arcLabels[0] = sensorRes.body.rangeLabels.green;
                        // tTotalHarmonicDistortionAccelerationData.options.arcLabels[1] = sensorRes.body.rangeLabels.yellow;
                        // let velocityG = sensorRes.body.rangeLabels.green;
                        // let velocityY = sensorRes.body.rangeLabels.yellow;
                        // let velocityR = max;
    
                        tTotalHarmonicDistortionAccelerationData.options.arcLabels[0] = ((max * this.dataGadge[mCount].arcDelimiters[0]) / 100).toFixed(1).toString();
                        tTotalHarmonicDistortionAccelerationData.options.arcLabels[1] = ((max * this.dataGadge[mCount].arcDelimiters[1]) / 100).toFixed(1).toString();
    
                        let velocityG = this.dataGadge[mCount].arcDelimiters[0];
                        let velocityY = this.dataGadge[mCount].arcDelimiters[1];
                        let velocityR = max;
    
    
                        tTotalHarmonicDistortionAccelerationData.options.arcColors[0] = "#72FF13";
                        tTotalHarmonicDistortionAccelerationData.options.arcColors[1] = "#FAA700";
                        tTotalHarmonicDistortionAccelerationData.options.arcColors[2] = "#ff2a1b";
            
                        if (
                          tTotalHarmonicDistortionAccelerationData.centralLabel <= tTotalHarmonicDistortionAccelerationData.options.arcLabels[0]
                        ) {
                          // accelerationData.options.centralLabel=
                          tTotalHarmonicDistortionAccelerationData.options.needleColor = "#72FF13";
                        } else if (
                          tTotalHarmonicDistortionAccelerationData.centralLabel > tTotalHarmonicDistortionAccelerationData.options.arcLabels[0] &&
                          tTotalHarmonicDistortionAccelerationData.centralLabel <= tTotalHarmonicDistortionAccelerationData.options.arcLabels[1]
                        ) {
                          tTotalHarmonicDistortionAccelerationData.options.needleColor = "#FAA700";
                        } else {
                          tTotalHarmonicDistortionAccelerationData.options.needleColor = "#ff2a1b";
                        }
            
                        this.TotalHarmonicDistortionData.push(tTotalHarmonicDistortionAccelerationData);
                        this.gaugeShow=true;
                      }
                    
                    }
                    if(this.TotalHarmonicDistortionData.length >=1){                  
                      setTimeout(() => {
                      this.totalharmonicdistortionloading=false;
                      }, 1000);
                    }
    
                  }
    
                }
                    
              }
    
            }
    
          });
  }

  public async CumulativeEnergyKWH(){

    
      //Enerty Meter:: Line Graph :: voltage.      
      //  this.service.getDataWithQuery(this.emeterData+'/trends-cumulative-energy/'+this.userID+"/"+this.generic_asset_id+"/hour").then((sRes) => {
      // this.service.getDataWithQuery('http://localhost:3105/emeter/trends-cumulative-energy/'+this.userID+"/"+this.serialNo+"/hour").then((sRes) => {
       this.service.getDataWithQuery(this.emeterData+'/trends-cumulative-energy-v2/'+this.userID+"/"+this.generic_asset_id+"/hour").then((sRes) => {
      // this.service.getDataWithQuery('http://localhost:3105/emeter/trends-cumulative-energy-v2/'+this.userID+"/"+this.generic_asset_id+"/hour").then((sRes) => {
        
        let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

          let response = sensorRes.body;
          this.emCumulativeEnergyLineData =[];
          this.CumulativeEnergyLineChartColors =[];

          this.CumulativeEnergyLineChartOptions = response.name;
          this.emCumulativeEnergyLineUnit = response.symbol;
            if (response.sensor != undefined){

              if(response.sensor.length != 0){
                let barData= response.sensor;
                this.emCumulativeEnergyLineData.push(barData);              
              }

              if(response.rangeLabels.length != 0){              
                this.CumulativeEnergyLineChartColors.push(response.rangeLabels);
              }
              
              if(this.emCumulativeEnergyLineData.length >=1 || this.CumulativeEnergyLineChartColors.length >=1){                  
                setTimeout(() => {
                  this.trendsCumulativeEnergyloading=false;
                }, 1000);
              }
              
            }

            if(response.movingAvg != undefined){

              if(response.movingAvg.length != 0){

                  this.emCumulativeEnergyLineMovingAvg = response.movingAvg;
                  this.emCumulativeEnergyLineMovingCount = response.movingCount;
              }
            }


        }

      });
  }

  async cumulativeGauge(){
          //Enerty Meter:: Gauge Graph :: Cumulative Energy.
          // await this.service.getDataWithQuery(this.emeterData +"/cumulative-energy/"+this.userID+"/"+this.generic_asset_id).then((sRes) => {
          // await this.service.getDataWithQuery(`http://localhost:3105/emeter` +"/cumulative-energy/"+this.userID+"/"+this.generic_asset_id).then((sRes) => {
          await this.service.getDataWithQuery(this.emeterData +"/cumulative-energy-v2/"+this.userID+"/"+this.generic_asset_id).then((sRes) => {
          // await this.service.getDataWithQuery(`http://localhost:3105/emeter` +"/cumulative-energy-v2/"+this.userID+"/"+this.generic_asset_id).then((sRes) => {
      
              let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
            
              if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
              
                let response = sensorRes.body;
                //this.KWHSettingID = response.thresholdsID;
                this.CumulativeEnergyData =[];
                if (response.sensor != undefined){
                  if(response.sensor.length != 0){
      
                    this.dataGadge= response.sensor;
      
                    if (this.dataGadge.length !== 0) {
      
                      let tempArr = [];
                      let bottomLab = "";
                    
                      for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
                        const parsedValue = JSON.parse(this.dataGadge[mCount].value);
                        if (parsedValue === 0 && this.dataGadge[mCount].needle === false) {
      
                            bottomLab = "0";
                        } else {
                          bottomLab =parsedValue <= 0 ? "0 KWH": this.dataGadge[mCount].symbol === "C" ? parsedValue.toFixed(2) +
                                " °" + this.dataGadge[mCount].icon : parsedValue.toFixed(2) +" " +this.dataGadge[mCount].icon;
                        }
      
                        this.Itemsymbol = this.dataGadge[mCount].symbol;
                        let needleValueRes;
                        if (this.dataGadge[mCount].symbol === "m/sec²") {
                          needleValueRes = (parsedValue);
                        } else if (this.dataGadge[mCount].symbol === "mm/sec") {
                          needleValueRes = (parsedValue);
                        } else if (this.dataGadge[mCount].symbol === "deg") {
                          needleValueRes = parsedValue;
                        } else {
                          //needleValueRes = parsedValue;
                          needleValueRes = (parsedValue );
                        }
      
                        let centerLab = parsedValue < 0 ? "N/A": parsedValue;
                        let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors: ["transparent", "transparent", "transparent"];
                        let range_label =this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel: [];
                        let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters: [];
                        let value = parsedValue < 0 ? "N/A": parsedValue?.toFixed(2);
                        const formatted_date = moment.parseZone(this.dataGadge[mCount].period_start).format("YYYY-MM-DD\n HH:mm:ss");
                        const CumulativeEnergyAccelerationData = {
                          // value:value,
                          formatted_date:formatted_date,
                          needleValue: needleValueRes,
                          centralLabel: centerLab,
                          outerNeedle: false,
                          canvasWidth: 150,
                          name: this.dataGadge[mCount].name,
                          key: this.dataGadge[mCount].key,
                          bottomLabel: bottomLab,
                          hasneedle: this.dataGadge[mCount].needle,
                          options: {
                            hasNeedle: this.dataGadge[mCount].needle,
                            needleColor: "black",
                            needleUpdateSpeed: "",
                            arcColors: arc_colors,
                            arcLabels: [] as string[],
                            arcDelimiters: this.dataGadge[mCount].arcDelimiters,
                            rangeLabel: range_label,
                            needleStartValue: 0,
                          },
                        };
      
                        if (arc_Delimiters[0] < 100 && arc_Delimiters[0] > 0 && arc_Delimiters[1] > 0 && arc_Delimiters[0] < arc_Delimiters[1] && arc_Delimiters[1] < 100) {
      
                          let max = range_label[1] != null ? range_label[1] : 0;
                         
      
      
                          CumulativeEnergyAccelerationData.options.arcLabels[0] = ((max * this.dataGadge[mCount].arcDelimiters[0]) / 100).toFixed(1).toString();
                          CumulativeEnergyAccelerationData.options.arcLabels[1] = ((max * this.dataGadge[mCount].arcDelimiters[1]) / 100).toFixed(1).toString();
      
                          let velocityG = this.dataGadge[mCount].arcDelimiters[0];
                          let velocityY = this.dataGadge[mCount].arcDelimiters[1];
                          let velocityR = max;
      
                          CumulativeEnergyAccelerationData.options.arcColors[0] = "#72FF13";
                          CumulativeEnergyAccelerationData.options.arcColors[1] = "#FAA700";
                          CumulativeEnergyAccelerationData.options.arcColors[2] = "#ff2a1b";
              
                          if (
                            CumulativeEnergyAccelerationData.centralLabel <= CumulativeEnergyAccelerationData.options.arcLabels[0]
                          ) {
                            // accelerationData.options.centralLabel=
                            CumulativeEnergyAccelerationData.options.needleColor = "#72FF13";
                          } else if (
                            CumulativeEnergyAccelerationData.centralLabel > CumulativeEnergyAccelerationData.options.arcLabels[0] &&
                            CumulativeEnergyAccelerationData.centralLabel <= CumulativeEnergyAccelerationData.options.arcLabels[1]
                          ) {
                            CumulativeEnergyAccelerationData.options.needleColor = "#FAA700";
                          } else {
                            CumulativeEnergyAccelerationData.options.needleColor = "#ff2a1b";
                          }
              
                          this.CumulativeEnergyData.push(CumulativeEnergyAccelerationData);
                          this.gaugeShow=true;
                        }
                      }
                        console.log(this.CumulativeEnergyData[0])
                        this.CumulativeEnergyData.forEach((item:any,index:number)=>{
                          let division_factor = 1000
                          if (index === 0){
                             item.division_factor = 1
                            return; // ✅ skip first item
                          }
                            
                          item.division_factor = division_factor
                          // item.centralLabel=item?.centralLabel/division_factor
                          item.centralLabel=item?.centralLabel;
                          item.needleValue=item?.needleValue/division_factor
                          let [val,symbol]=item.bottomLabel.split(' ')
                          // val=((Number(val)/division_factor).toFixed(2)).toString()
                          val=((Number(val)).toFixed(2)).toString()
                          item.bottomLabel=`${val} ${symbol}`
                          // console.log(item.options.arcLabels,"-------------------=============================----------------------")
                          item.options.arcLabels=item.options.arcLabels.map((label:any)=>(Number(label)/division_factor).toString())
                          item.options.rangeLabel=item.options.rangeLabel.map((label:any)=>(Number(label)/division_factor).toString())
                        })
                        console.log(this.CumulativeEnergyData[0])
                      if(this.CumulativeEnergyData.length >=1){           
                          setTimeout(() => {
                            this.cumulativeenergyloading = false;
                          }, 1000);
                      }
                      
      
                    }
      
                  }
                      
                }
      
              }
      
            });
  }

  public async PowerFactorFrequency(){


      //Enerty Meter:: Line Graph :: Current.      
       this.service.getDataWithQuery(this.emeterData+'/trends-frequency/'+this.userID+"/"+this.generic_asset_id+"/hour").then((sRes) => {
        
        let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

          let response = sensorRes.body;
          this.emFrequencyLineData =[];
          this.FrequencyLineChartColors =[];

          this.FrequencyLineChartOptions = response.name;
          this.emFrequencyLineUnit = response.symbol;
          

            if (response.sensor != undefined){

              if(response.sensor.length != 0){
                let barData= response.sensor;
                this.emFrequencyLineData.push(barData);              
              }

              if(response.rangeLabels.length != 0){              
                this.FrequencyLineChartColors.push(response.rangeLabels);
              }
              
              if(this.emFrequencyLineData.length >=1 || this.FrequencyLineChartColors.length >=1){                  
                setTimeout(() => {
                  this.trendsfrequencyloading=false;
                }, 1000);
              } 

              if(response.rangeLabels){
                let {min_value,max_value,threshold_1,threshold_2,orieX_default,orieY_default} = response.rangeLabels
                this.frequencyStripLines.push(min_value,threshold_1,threshold_2,orieX_default,orieY_default,max_value)
              }

            }

            if(response.movingAvg != undefined){

              if(response.movingAvg.length != 0){
  
                  this.emFrequencyMovingAvg = response.movingAvg;
                  this.emFrequencyMovingCount = response.movingCount;
              }
            }
        }

      });

      //Enerty Meter:: Line Graph :: Power Factor.      
       this.service.getDataWithQuery(this.emeterData+'/trends-power-factor/'+this.userID+"/"+this.generic_asset_id+"/hour").then((sRes) => {
        
        let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

          let response = sensorRes.body;
          this.emPowerFactorLineData =[];
          this.PowerFactorLineChartColors =[];

          this.PowerFactorLineChartOptions = response.name;
          this.emPowerFactorLineUnit = response.symbol;

            if (response.sensor != undefined){

              if(response.sensor.length != 0){
                let barData= response.sensor;
                this.emPowerFactorLineData.push(barData);              
              }

              if(response.rangeLabels.length != 0){              
                this.PowerFactorLineChartColors.push(response.rangeLabels);
              }
              
              if(this.emPowerFactorLineData.length >=1 || this.PowerFactorLineChartColors.length >=1){                  
                setTimeout(() => {
                  this.trendspowerfactorloading=false;
                }, 1000);
              } 
              if(response.rangeLabels){
                let {min_value,max_value,threshold_1,threshold_2,orieX_default,orieY_default} = response.rangeLabels
                this.powerFactorStripLines.push(min_value,threshold_1,threshold_2,orieX_default,orieY_default,max_value)
                
              }
            }

            if(response.movingAvg != undefined){

              if(response.movingAvg.length != 0){
  
                  this.emPowerFactorMovingAvg = response.movingAvg;
                  this.emPowerFactorMovingCount = response.movingCount;
              }
            }
        }
      });
      // let graphInterval1=setInterval(()=>{
      //   if(this.emPowerFactorFrequencyData.length >=1 && 
      //     (this.emPowerFactorLineData.length >=1 || this.PowerFactorLineChartColors.length >=1) &&
      //     (this.emFrequencyLineData.length >=1 || this.FrequencyLineChartColors.length >=1)
      //   ){                  
      //     this.powerfactorloading=false;
      //     this.trendspowerfactorloading=false;
      //     this.trendsfrequencyloading=false;
      //     clearInterval(graphInterval1)
      //   }
      // },2000)
    
  }

  PFGauge(){
          //Energy Meter:: Gauge Graph:: Power Factor / Frequency
          this.service.getDataWithQuery(this.emeterData +"/power-factor-frequency/"+this.userID+"/"+this.generic_asset_id).then((sRes) => {

            let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
          
            if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
              let response = sensorRes.body;
              this.emPowerFactorFrequencyData = [];
              if (response.sensor && response.sensor.length !== 0) {
                this.dataGadge = response.sensor;
                if (this.dataGadge.length !== 0) {
                  let bottomLab = "";
                  for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
                    const parsedValue = JSON.parse(this.dataGadge[mCount].value);
                    // Compute bottom label
                    if (parsedValue === 0 && this.dataGadge[mCount].needle === false) {
                      bottomLab = "N/A";
                    } else {
                      bottomLab = parsedValue <= 0
                        ? (this.dataGadge[mCount].name === "Frequency" ? "0 Hz" : "0")
                        : (this.dataGadge[mCount].symbol === "C"
                            ? Number(parsedValue).toFixed(0) + " °" + this.dataGadge[mCount].icon
                            : (this.dataGadge[mCount].name === "Frequency"
                                ? Number(parsedValue).toFixed(0) + " " + this.dataGadge[mCount].icon
                                : Number(parsedValue).toFixed(2) + " " + this.dataGadge[mCount].icon));
                    }
                    this.Itemsymbol = this.dataGadge[mCount].symbol;
                    let centerLab = parsedValue < 0 ? "N/A" : parsedValue;
                    let chartName = this.dataGadge[mCount].name;
                    // Common data from sensor
                    let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors : ["transparent", "transparent", "transparent"];
                    let range_label = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel : [];
                    let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters : [];
                    let value = parsedValue < 0 ? "N/A": parsedValue.toFixed(2);
                    if (chartName === "Power Factor") {
                      
                      // === New Logic: 3-segment gauge for Power Factor ===
                      if (range_label.length === 2) {
                        let gaugeMin = arc_Delimiters[0];
                        let gaugeMax = arc_Delimiters[1];
                        let rangeDifference = gaugeMax - gaugeMin;
                        let arc_label=[gaugeMin.toString(),gaugeMax.toString()]
                        
                        // console.log(this.dataGadge[mCount].arcDelimiters)
                        let threshold1 = gaugeMin ;
                        let threshold2 = gaugeMax ;
                      
                        let delimiter1 = (threshold1  * 100)  ;
                        let delimiter2 = (threshold2  * 100) ;
                        let pf_arcDelimiters = [delimiter1, delimiter2];
                        
                        let needleVal = parseFloat(this.dataGadge[mCount].value);
                        let percentage = needleVal  * 100;
                        
                        let needleColor = "";
                        if (needleVal <= threshold1) {
                          needleColor = "#ff2a1b"; // red
                        } else if (needleVal > threshold1 && needleVal <= threshold2) {
                          needleColor = "#FAA700"; // yellow
                        } else {
                          needleColor = "#72FF13"; // green
                        }
                        
                       
                        let pf_arcColors =  ["#ff2a1b", "#FAA700", "#72FF13"];
                        
                       
                        let pf_arcLabels = [
                          gaugeMin.toFixed(1),
                          threshold1.toFixed(1),
                          threshold2.toFixed(1),
                          gaugeMax.toFixed(1)
                        ];
                        const pfData = {
                          value:value,
                          needleValue: needleVal,
                          centralLabel: centerLab,
                          outerNeedle: false,
                          canvasWidth: 150,
                          name: chartName,
                          key: this.dataGadge[mCount].key,
                          bottomLabel: bottomLab,
                          hasneedle: this.dataGadge[mCount].needle,
                          options: {
                            hasNeedle: this.dataGadge[mCount].needle,
                            needleColor: needleColor,
                            needleUpdateSpeed: "",
                            arcColors: pf_arcColors,
                            arcLabels: arc_label,
                            arcDelimiters: pf_arcDelimiters,
                            rangeLabel: range_label,
                            needleStartValue: 0,
                          },
                        };
                        this.emPowerFactorFrequencyData.push(pfData);
                        this.gaugeShow = true;
                      }
                    } else if (chartName === "Frequency") {
                      
                      let RedUnderVal=0;
                      let yellowUnderVal=0;
                      let GreenUnderVal=0;
                      let greenOverVal=0;
                      let yellowOverVal=0;
                      let rangeDiffrence=0;
                                       
    
                      if(range_label.length === 2){
                       
                        
                        RedUnderVal =  parseFloat(arc_Delimiters[0]);
                        yellowUnderVal =  parseFloat(arc_Delimiters[1]);
                        GreenUnderVal = parseFloat(arc_Delimiters[2]);
                        greenOverVal =  parseFloat(arc_Delimiters[3]);
                        yellowOverVal =  parseFloat(arc_Delimiters[4]);
                        rangeDiffrence = (parseFloat(range_label[1])-parseFloat(range_label[0]));
                       
                      }
                      
                      let arc_Delimiters_values =[];
    
                      //1st value. 
                      let FirstVal = 0;
                      FirstVal = (RedUnderVal-parseFloat(range_label[0])); 
                      FirstVal = ((FirstVal*100)/rangeDiffrence);           
                      arc_Delimiters_values.push(FirstVal);
    
                      //2nd value.                   
                      let SecondsVal = 0;
                      SecondsVal = (yellowUnderVal-parseFloat(range_label[0])); 
                      SecondsVal = ((SecondsVal*100)/rangeDiffrence);           
                      arc_Delimiters_values.push(SecondsVal);
    
                      //3rd value.
                      let thirdVal = 0;
                      thirdVal = (GreenUnderVal-parseFloat(range_label[0])); 
                      thirdVal = ((thirdVal*100)/rangeDiffrence);           
                      arc_Delimiters_values.push(thirdVal);
    
                      //4th value. 
                      let FourthVal = 0;
                      FourthVal = (greenOverVal-parseFloat(range_label[0])); 
                      FourthVal = ((FourthVal*100)/rangeDiffrence);           
                      arc_Delimiters_values.push(FourthVal);
    
                      //5th value. 
                      let FifthVal = 0;
                      FifthVal = (yellowOverVal-parseFloat(range_label[0])); 
                      FifthVal = ((FifthVal*100)/rangeDiffrence);           
                      arc_Delimiters_values.push(FifthVal);
                      
    
                      let needleVal = 0;
                      let needleMinPercentage = 0;
                      let needleMinValue = 0;
                      let needleMaxPercentage = 0;                  
                      let needleMaxValue = 0;
                      let percentage = 0;
    
                      needleVal = this.dataGadge[mCount].value;
    
                      
                      //Update needleValueRes.
                      if(this.dataGadge[mCount].value <=RedUnderVal){
    
                        needleMinValue = 0;
                        needleMaxValue = RedUnderVal;
                        needleMinPercentage = 0;
                        needleMaxPercentage = arc_Delimiters_values[0];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
    
                      }else if(needleVal >= RedUnderVal && needleVal <= yellowUnderVal){
    
                        needleMinValue = RedUnderVal;
                        needleMaxValue = yellowUnderVal;
                        needleMinPercentage = arc_Delimiters_values[0];
                        needleMaxPercentage = arc_Delimiters_values[1];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
                        
                      }else if(needleVal >= yellowUnderVal && needleVal <= GreenUnderVal){
    
                        needleMinValue = yellowUnderVal;
                        needleMaxValue = GreenUnderVal;
                        needleMinPercentage = arc_Delimiters_values[1];
                        needleMaxPercentage = arc_Delimiters_values[2];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
    
                      }else if(needleVal >= GreenUnderVal && needleVal <= greenOverVal){
    
                        needleMinValue = GreenUnderVal;
                        needleMaxValue = greenOverVal;
                        needleMinPercentage = arc_Delimiters_values[2];
                        needleMaxPercentage = arc_Delimiters_values[3];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
    
                      }else if(needleVal >= greenOverVal && needleVal <= yellowOverVal){
    
                        needleMinValue = greenOverVal;
                        needleMaxValue = yellowOverVal;
                        needleMinPercentage = arc_Delimiters_values[3];
                        needleMaxPercentage = arc_Delimiters_values[4];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
    
                      }else{
    
                        needleMinValue = yellowOverVal;
                        needleMaxValue = range_label[1];
                        needleMinPercentage = arc_Delimiters_values[4];
                        needleMaxPercentage = arc_Delimiters_values[5];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
    
                      }
    
                      /***********my new logic end here for new gauge chart for PF***********/
                      
                      const emPowerFactorFrequencyAccelerationData = {
                        needleValue: needleVal,
                        centralLabel: centerLab,
                        outerNeedle: false,
                        canvasWidth: 150,
                        name: this.dataGadge[mCount].name,
                        key: this.dataGadge[mCount].key,
                        bottomLabel: bottomLab,
                        hasneedle: this.dataGadge[mCount].needle,
                        options: {
                          hasNeedle: this.dataGadge[mCount].needle,
                          needleColor: "black",
                          needleUpdateSpeed: "",
                          arcColors: arc_colors,
                          arcLabels: [] as string[],
                          arcDelimiters: arc_Delimiters_values,
                          rangeLabel: range_label,
                          needleStartValue: 0,
                        },
                      };
    
                      if (arc_Delimiters_values[0] < 100 && arc_Delimiters_values[0] > 0 && arc_Delimiters_values[1] > 0 && arc_Delimiters_values[0] < arc_Delimiters_values[1] && arc_Delimiters_values[1] < 100) {
    
                        let max = range_label[1] != null ? range_label[1] : 0;
                        
                        emPowerFactorFrequencyAccelerationData.options.arcLabels[0] = (RedUnderVal).toFixed(1).toString();
                        emPowerFactorFrequencyAccelerationData.options.arcLabels[1] = (yellowUnderVal).toFixed(1).toString();
                        emPowerFactorFrequencyAccelerationData.options.arcLabels[2] = (GreenUnderVal).toFixed(1).toString();
                        emPowerFactorFrequencyAccelerationData.options.arcLabels[3] = (greenOverVal).toFixed(1).toString();
                        emPowerFactorFrequencyAccelerationData.options.arcLabels[4] = (yellowOverVal).toFixed(1).toString();
    
                        emPowerFactorFrequencyAccelerationData.options.arcColors[0] = "#ff2a1b";
                        emPowerFactorFrequencyAccelerationData.options.arcColors[1] = "#FAA700";
                        emPowerFactorFrequencyAccelerationData.options.arcColors[2] = "#72FF13";
                        if(chartName == 'Power Factor'){ emPowerFactorFrequencyAccelerationData.options.arcColors[3] = "#FAA700";}
                        if(chartName == 'Frequency'){ emPowerFactorFrequencyAccelerationData.options.arcColors[3] = "#72FF13"; }                    
                        emPowerFactorFrequencyAccelerationData.options.arcColors[4] = "#FAA700";
                        emPowerFactorFrequencyAccelerationData.options.arcColors[5] = "#ff2a1b";
            
                        if (emPowerFactorFrequencyAccelerationData.centralLabel <= emPowerFactorFrequencyAccelerationData.options.arcLabels[0]
                        ) {
                          emPowerFactorFrequencyAccelerationData.options.needleColor = "#ff2a1b";
                        } else if (
                          emPowerFactorFrequencyAccelerationData.centralLabel > emPowerFactorFrequencyAccelerationData.options.arcLabels[0] &&
                          emPowerFactorFrequencyAccelerationData.centralLabel <= emPowerFactorFrequencyAccelerationData.options.arcLabels[1]
                        ) {
                          emPowerFactorFrequencyAccelerationData.options.needleColor = "#FAA700";
                        } else if (
                          emPowerFactorFrequencyAccelerationData.centralLabel > emPowerFactorFrequencyAccelerationData.options.arcLabels[1] &&
                          emPowerFactorFrequencyAccelerationData.centralLabel <= emPowerFactorFrequencyAccelerationData.options.arcLabels[2]
                        ){
    
                          emPowerFactorFrequencyAccelerationData.options.needleColor = "#72FF13";
                        }else if (
                          emPowerFactorFrequencyAccelerationData.centralLabel > emPowerFactorFrequencyAccelerationData.options.arcLabels[2] &&
                          emPowerFactorFrequencyAccelerationData.centralLabel <= emPowerFactorFrequencyAccelerationData.options.arcLabels[3]
                        ){
                          if(chartName == 'Power Factor'){ emPowerFactorFrequencyAccelerationData.options.needleColor = "#FAA700";}
                          if(chartName == 'Frequency'){ emPowerFactorFrequencyAccelerationData.options.needleColor = "#72FF13"; }  
                          //emPowerFactorFrequencyAccelerationData.options.needleColor = "#72FF13";
                        }else if (
                          emPowerFactorFrequencyAccelerationData.centralLabel > emPowerFactorFrequencyAccelerationData.options.arcLabels[3] &&
                          emPowerFactorFrequencyAccelerationData.centralLabel <= emPowerFactorFrequencyAccelerationData.options.arcLabels[4]
                        ){
                          emPowerFactorFrequencyAccelerationData.options.needleColor = "#FAA700";
                        }else{
                          emPowerFactorFrequencyAccelerationData.options.needleColor = "#ff2a1b";
                        }
                        
                        //update range now. 
                        // console.log("Frequency pf")
                        // console.log(emPowerFactorFrequencyAccelerationData)
                        this.emPowerFactorFrequencyData.push(emPowerFactorFrequencyAccelerationData);                   
                        this.gaugeShow=true;
                      }
                    } // end if/else for chartName
                  } // end for loop
                  if (this.emPowerFactorFrequencyData.length >= 1) {
                    setTimeout(()=>{
                      this.powerfactorloading = false;
                    },1000)
                    // console.log(this.emPowerFactorFrequencyData)
                  }
                }
              }
            }
            
    
          });
  }

  public async PeakDemandKWKVA(){


      // Enerty Meter:: Line Graph :: KW Demand.      
       this.service.getDataWithQuery(this.emeterData+'/trends-kw-demand/'+this.userID+"/"+this.generic_asset_id+"/hour").then((sRes) => {
      // this.service.getDataWithQuery('http://localhost:3105/emeter/trends-kw-demand/'+this.userID+"/"+this.serialNo+"/hour").then((sRes) => {
        
        let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

          let response = sensorRes.body;
          this.emKwDemandLineData =[];
          this.KwDemandLineChartColors =[];

          this.KwDemandLineChartOptions = response.name;
          this.emKwDemandLineUnit = response.symbol; 
          if (response.sensor != undefined){

            if(response.sensor.length != 0){
              let barData= response.sensor;
              this.emKwDemandLineData.push(barData);              
            }

            if(response.rangeLabels.length != 0){              
              this.KwDemandLineChartColors.push(response.rangeLabels);
            }
            
            if(this.emKwDemandLineData.length >=1 || this.KwDemandLineChartColors.length >=1){                  
              setTimeout(() => {
                this.trendskwdemandloading=false;
              }, 1000);
            } 

            if(response.rangeLabels){
              let {min_value,max_value,threshold_1,threshold_2,threshold_3,orieY_default} = response.rangeLabels
              this.kwStripLines=[];
              this.kwStripLines.push(min_value,threshold_1,threshold_2,threshold_3,orieY_default,max_value)
            }
            // console.log("kw striplines: " + this.kwStripLines)

          }

          if(response.movingAvg != undefined){

            if(response.movingAvg.length != 0){

                this.emKwDemandMovingAvg = response.movingAvg;
                this.emKwDemandMovingCount = response.movingCount;
            }
          }

        }

      });
      // Enerty Meter:: Line Graph :: KVA Demand.      
      // this.service.getDataWithQuery('http://localhost:3105/emeter/trends-kva-demand/'+this.userID+"/"+this.serialNo+"/hour").then((sRes) => {
      this.service.getDataWithQuery(this.emeterData+'/trends-kva-demand/'+this.userID+"/"+this.generic_asset_id+"/hour").then((sRes) => {
        
        let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

          let response = sensorRes.body;
          this.emKvaDemandLineData =[];
          this.KvaDemandLineChartColors =[];

          this.KvaDemandLineChartOptions = response.name;
          this.emKvaDemandLineUnit = response.symbol; 
          if (response.sensor != undefined){

            if(response.sensor.length != 0){
              let barData= response.sensor;
              this.emKvaDemandLineData.push(barData);              
            }

            if(response.rangeLabels.length != 0){              
              this.KvaDemandLineChartColors.push(response.rangeLabels);
            }
            
            if(this.emKvaDemandLineData.length >=1 || this.KvaDemandLineChartColors.length >=1){                  
              setTimeout(() => {
                this.trendskvademandloading=false;
              }, 1000);
            } 

            if(response.rangeLabels){
              let {min_value,max_value,threshold_1,threshold_2,threshold_3,orieY_default} = response.rangeLabels
              this.kvaStripLines=[];
              this.kvaStripLines.push(min_value,threshold_1,threshold_2,threshold_3,orieY_default,max_value)
            }
            // console.log("kw striplines: " + this.kvaStripLines)

          }

          if(response.movingAvg != undefined){

            if(response.movingAvg.length != 0){

                this.emKvaDemandMovingAvg = response.movingAvg;
                this.emKvaDemandMovingCount = response.movingCount;
            }
          }

        }

      });
    
  }
  peakDemandGauge(){
          //Enerty Meter:: Gauge Graph :: Peak Demand.
      // this.service.getDataWithQuery(this.emeterData +"/peak-demand/"+this.userID+"/"+this.serialNo).then((sRes) => {
      // this.service.getDataWithQuery('http://localhost:3105/emeter/peak-demand/'+this.userID+"/"+this.serialNo).then((sRes) => {

      //   let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
      
      //   if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
        
      //     let response = sensorRes.body;
      //     //this.peakDemandKW_PeakDemandKVA_SettingID = response.thresholdsID;
      //     this.emPeakDemandData =[];
      //     if (response.sensor != undefined){
      //       if(response.sensor.length != 0){

      //         this.dataGadge= response.sensor;

      //         if (this.dataGadge.length !== 0) {

      //           let tempArr = [];
      //           let bottomLab = "";
              
      //           for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
              
      //             if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {

      //                 bottomLab = "0";
      //             } else {
      //               bottomLab =JSON.parse(this.dataGadge[mCount].value) <= 0 ? this.dataGadge[mCount].name === "Instantaneous Power (KVA)" ? "0 KVA" :"0 KW": this.dataGadge[mCount].symbol === "C" ? JSON.parse(this.dataGadge[mCount].value).toFixed(2) +
      //                     " °" + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value).toFixed(2) +" " +this.dataGadge[mCount].icon;
      //             }

      //             this.Itemsymbol = this.dataGadge[mCount].symbol;
      //             let needleValueRes;
      //             if (this.dataGadge[mCount].symbol === "m/sec²") {
      //               needleValueRes = (JSON.parse(this.dataGadge[mCount].value) * 100) /parseFloat(this.dataGadge[mCount].rangelabel[1]);
      //             } else if (this.dataGadge[mCount].symbol === "mm/sec") {
      //               needleValueRes = (JSON.parse(this.dataGadge[mCount].value) * 100) /parseFloat(this.dataGadge[mCount].rangelabel[1]);
      //             } else if (this.dataGadge[mCount].symbol === "deg") {
      //               needleValueRes = JSON.parse(this.dataGadge[mCount].value);
      //             } else {
      //               //needleValueRes = JSON.parse(this.dataGadge[mCount].value);
      //               needleValueRes = (JSON.parse(this.dataGadge[mCount].value) * 100) / parseFloat(this.dataGadge[mCount].rangelabel[1]);
      //             }

      //             let centerLab = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);
      //             let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors: ["transparent", "transparent", "transparent"];
      //             let range_label =this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel: [];
      //             let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters: [];
      //             let value = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);

      //             const emPeakDemandAccelerationData = {
      //               // value:value,
      //               needleValue: needleValueRes,
      //               centralLabel: centerLab,
      //               outerNeedle: false,
      //               canvasWidth: 150,
      //               name: this.dataGadge[mCount].name,
      //               key: this.dataGadge[mCount].key,
      //               bottomLabel: bottomLab,
      //               hasneedle: this.dataGadge[mCount].needle,
      //               options: {
      //                 hasNeedle: this.dataGadge[mCount].needle,
      //                 needleColor: "black",
      //                 needleUpdateSpeed: "",
      //                 arcColors: arc_colors,
      //                 arcLabels: [] as string[],
      //                 arcDelimiters: this.dataGadge[mCount].arcDelimiters,
      //                 rangeLabel: range_label,
      //                 needleStartValue: 0,
      //               },
      //             };

      //             if (arc_Delimiters[0] < 100 && arc_Delimiters[0] > 0 && arc_Delimiters[1] > 0 && arc_Delimiters[0] < arc_Delimiters[1] && arc_Delimiters[1] < 100) {

      //               let max = range_label[1] != null ? range_label[1] : 0;
      //               // emPeakDemandAccelerationData.options.arcLabels[0] = sensorRes.body.rangeLabels.green;
      //               // emPeakDemandAccelerationData.options.arcLabels[1] = sensorRes.body.rangeLabels.yellow;
      //               // let velocityG = sensorRes.body.rangeLabels.green;
      //               // let velocityY = sensorRes.body.rangeLabels.yellow;
      //               // let velocityR = max;

                    
      //               emPeakDemandAccelerationData.options.arcLabels[0] = ((max * this.dataGadge[mCount].arcDelimiters[0]) / 100).toFixed(1).toString();
      //               emPeakDemandAccelerationData.options.arcLabels[1] = ((max * this.dataGadge[mCount].arcDelimiters[1]) / 100).toFixed(1).toString();
      //               let velocityG = this.dataGadge[mCount].arcDelimiters[0];
      //               let velocityY = this.dataGadge[mCount].arcDelimiters[1];
      //               let velocityR = max;


      //               emPeakDemandAccelerationData.options.arcColors[0] = "#72FF13";
      //               emPeakDemandAccelerationData.options.arcColors[1] = "#FAA700";
      //               emPeakDemandAccelerationData.options.arcColors[2] = "#ff2a1b";
        
      //               if (
      //                 emPeakDemandAccelerationData.centralLabel <= emPeakDemandAccelerationData.options.arcLabels[0]
      //               ) {
      //                 // accelerationData.options.centralLabel=
      //                 emPeakDemandAccelerationData.options.needleColor = "#72FF13";
      //               } else if (
      //                 emPeakDemandAccelerationData.centralLabel > emPeakDemandAccelerationData.options.arcLabels[0] &&
      //                 emPeakDemandAccelerationData.centralLabel <= emPeakDemandAccelerationData.options.arcLabels[1]
      //               ) {
      //                 emPeakDemandAccelerationData.options.needleColor = "#FAA700";
      //               } else {
      //                 emPeakDemandAccelerationData.options.needleColor = "#ff2a1b";
      //               }
        
      //               this.emPeakDemandData.push(emPeakDemandAccelerationData);
      //               this.gaugeShow=true;
      //             }
                  
                
      //           }

      //           if(this.emPeakDemandData.length >=1){                  
      //             setTimeout(() => {
      //               this.peakdemandloading=false;
      //             }, 1000);
      //           }
                

      //         }

      //       }
                
      //     }

      //   }

      // });

      // this.service.getDataWithQuery('http://localhost:3105/emeter/peak-demand/'+this.userID+"/"+this.serialNo).then((sRes) => {
        this.service.getDataWithQuery(this.emeterData +"/peak-demand/"+this.userID+"/"+this.generic_asset_id).then((sRes) => {

          let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
        
          if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
          
            let response = sensorRes.body;
  
            //this.powerFactor_FrequencySettingID = response.thresholdsID;
            this.emPeakDemandData =[];
            if (response.sensor != undefined){
              if(response.sensor.length != 0){
  
                this.dataGadge= response.sensor;
  
                if (this.dataGadge.length !== 0) {
  
                  let tempArr = [];
                  let bottomLab = "";
                
                  for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
              
                    if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {
                        bottomLab = "N/A";
                    } else {
                      // bottomLab =  JSON.parse(this.dataGadge[mCount].value) <= 0 ? this.dataGadge[mCount].name==="Frequency" ? "0 Hz" : "0" : this.dataGadge[mCount].symbol === "C" 
                      //       ? Number(JSON.parse(this.dataGadge[mCount].value)).toFixed(0) + " °" + this.dataGadge[mCount].icon 
                      //       : this.dataGadge[mCount].name==="Frequency" ?Number(JSON.parse(this.dataGadge[mCount].value)).toFixed(0) + " " + this.dataGadge[mCount].icon:Number(JSON.parse(this.dataGadge[mCount].value)).toFixed(2) + " " + this.dataGadge[mCount].icon;
                      bottomLab =JSON.parse(this.dataGadge[mCount].value.toFixed(2)) <= 0 ? this.dataGadge[mCount].name === "Instantaneous Power (KVA)" ? "Asset off" :"Asset off": this.dataGadge[mCount].symbol === "C" ? JSON.parse(this.dataGadge[mCount].value).toFixed(2) +
                                          " °" + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value).toFixed(2) +" " +this.dataGadge[mCount].icon;
                    }
                    this.Itemsymbol = this.dataGadge[mCount].symbol;              
  
                    let centerLab = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);
                    let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors: ["transparent", "transparent", "transparent"];
                   
                    let range_label =this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel: [];
                    let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters: [];
                    let value = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value).toFixed(2);
                    let chartName = this.dataGadge[mCount].name;
  
                    /***********my new logic start for new gauge chart for PF***********/
  
                    
                    let RedUnderVal=0;
                    let yellowUnderVal=0;
                    let GreenUnderVal=0;
                    let greenOverVal=0;
                    let yellowOverVal=0;
                    let rangeDiffrence=0;
                                     
  
                    if(range_label.length === 2){
                     
                      
                      RedUnderVal =  parseFloat(arc_Delimiters[0]);
                      yellowUnderVal =  parseFloat(arc_Delimiters[1]);
                      GreenUnderVal = parseFloat(arc_Delimiters[2]);
                      greenOverVal =  parseFloat(arc_Delimiters[3]);
                      yellowOverVal =  parseFloat(arc_Delimiters[4]);
                      rangeDiffrence = (parseFloat(range_label[1])-parseFloat(range_label[0]));
                     
                    }
                    
                    let arc_Delimiters_values =[];
  
                    //1st value. 
                    let FirstVal = 0;
                    FirstVal = (RedUnderVal-parseFloat(range_label[0])); 
                    FirstVal = ((FirstVal*100)/rangeDiffrence);           
                    arc_Delimiters_values.push(FirstVal);
  
                    //2nd value.                   
                    let SecondsVal = 0;
                    SecondsVal = (yellowUnderVal-parseFloat(range_label[0])); 
                    SecondsVal = ((SecondsVal*100)/rangeDiffrence);           
                    arc_Delimiters_values.push(SecondsVal);
  
                    //3rd value.
                    let thirdVal = 0;
                    thirdVal = (GreenUnderVal-parseFloat(range_label[0])); 
                    thirdVal = ((thirdVal*100)/rangeDiffrence);           
                    arc_Delimiters_values.push(thirdVal);
  
                    //4th value. 
                    let FourthVal = 0;
                    FourthVal = (greenOverVal-parseFloat(range_label[0])); 
                    FourthVal = ((FourthVal*100)/rangeDiffrence);           
                    arc_Delimiters_values.push(FourthVal);
  
                    //5th value. 
                    let FifthVal = 0;
                    FifthVal = (yellowOverVal-parseFloat(range_label[0])); 
                    FifthVal = ((FifthVal*100)/rangeDiffrence);           
                    arc_Delimiters_values.push(FifthVal);
                    
  
                    let needleVal = 0;
                    let needleMinPercentage = 0;
                    let needleMinValue = 0;
                    let needleMaxPercentage = 0;                  
                    let needleMaxValue = 0;
                    let percentage = 0;
  
                    needleVal = this.dataGadge[mCount].value;
  
                    
                    //Update needleValueRes.
                    if(this.dataGadge[mCount].value <=RedUnderVal){
  
                      needleMinValue = 0;
                      needleMaxValue = RedUnderVal;
                      needleMinPercentage = 0;
                      needleMaxPercentage = arc_Delimiters_values[0];
                      percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
  
                    }else if(needleVal >= RedUnderVal && needleVal <= yellowUnderVal){
  
                      needleMinValue = RedUnderVal;
                      needleMaxValue = yellowUnderVal;
                      needleMinPercentage = arc_Delimiters_values[0];
                      needleMaxPercentage = arc_Delimiters_values[1];
                      percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
                      
                    }else if(needleVal >= yellowUnderVal && needleVal <= GreenUnderVal){
  
                      needleMinValue = yellowUnderVal;
                      needleMaxValue = GreenUnderVal;
                      needleMinPercentage = arc_Delimiters_values[1];
                      needleMaxPercentage = arc_Delimiters_values[2];
                      percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
  
                    }else if(needleVal >= GreenUnderVal && needleVal <= greenOverVal){
  
                      needleMinValue = GreenUnderVal;
                      needleMaxValue = greenOverVal;
                      needleMinPercentage = arc_Delimiters_values[2];
                      needleMaxPercentage = arc_Delimiters_values[3];
                      percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
  
                    }else if(needleVal >= greenOverVal && needleVal <= yellowOverVal){
  
                      needleMinValue = greenOverVal;
                      needleMaxValue = yellowOverVal;
                      needleMinPercentage = arc_Delimiters_values[3];
                      needleMaxPercentage = arc_Delimiters_values[4];
                      percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
  
                    }else{
  
                      needleMinValue = yellowOverVal;
                      needleMaxValue = range_label[1];
                      needleMinPercentage = arc_Delimiters_values[4];
                      needleMaxPercentage = arc_Delimiters_values[5];
                      percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
  
                    }
  
                    /***********my new logic end here for new gauge chart for PF***********/
                    const emPowerFactorFrequencyAccelerationData = {
                      needleValue: needleVal,
                      centralLabel: centerLab,
                      outerNeedle: false,
                      canvasWidth: 150,
                      name: this.dataGadge[mCount].name,
                      key: this.dataGadge[mCount].key,
                      bottomLabel: bottomLab,
                      hasneedle: this.dataGadge[mCount].needle,
                      options: {
                        hasNeedle: this.dataGadge[mCount].needle,
                        needleColor: "black",
                        needleUpdateSpeed: "",
                        arcColors: arc_colors,
                        arcLabels: [] as string[],
                        arcDelimiters: arc_Delimiters_values,
                        rangeLabel: range_label,
                        needleStartValue: 0,
                      },
                    };
  
                    if (arc_Delimiters_values[0] < 100 && arc_Delimiters_values[0] > 0 && arc_Delimiters_values[1] > 0 && arc_Delimiters_values[0] < arc_Delimiters_values[1] && arc_Delimiters_values[1] < 100) {
  
                      let max = range_label[1] != null ? range_label[1] : 0;
                      
                      emPowerFactorFrequencyAccelerationData.options.arcLabels[0] = (RedUnderVal).toFixed(1).toString();
                      emPowerFactorFrequencyAccelerationData.options.arcLabels[1] = (yellowUnderVal).toFixed(1).toString();
                      // emPowerFactorFrequencyAccelerationData.options.arcLabels[2] = (GreenUnderVal).toFixed(1).toString();
                      emPowerFactorFrequencyAccelerationData.options.arcLabels[3] = (greenOverVal).toFixed(1).toString();
                      emPowerFactorFrequencyAccelerationData.options.arcLabels[4] = (yellowOverVal).toFixed(1).toString();
  
                      emPowerFactorFrequencyAccelerationData.options.arcColors[0] = "#ff2a1b";
                      emPowerFactorFrequencyAccelerationData.options.arcColors[1] = "#FAA700";
                      emPowerFactorFrequencyAccelerationData.options.arcColors[2] = "#72FF13";
                      if(chartName == 'Instantaneous Power (KW)'){ emPowerFactorFrequencyAccelerationData.options.arcColors[3] = "#72FF13";}
                      if(chartName == 'Instantaneous Power (KVA)'){ emPowerFactorFrequencyAccelerationData.options.arcColors[3] = "#72FF13"; }                    
                      emPowerFactorFrequencyAccelerationData.options.arcColors[4] = "#FAA700";
                      emPowerFactorFrequencyAccelerationData.options.arcColors[5] = "#ff2a1b";
          
                      if (emPowerFactorFrequencyAccelerationData.centralLabel <= emPowerFactorFrequencyAccelerationData.options.arcLabels[0]
                      ) {
                        emPowerFactorFrequencyAccelerationData.options.needleColor = "#ff2a1b";
                      } else if (
                        emPowerFactorFrequencyAccelerationData.centralLabel > emPowerFactorFrequencyAccelerationData.options.arcLabels[0] &&
                        emPowerFactorFrequencyAccelerationData.centralLabel <= emPowerFactorFrequencyAccelerationData.options.arcLabels[1]
                      ) {
                        emPowerFactorFrequencyAccelerationData.options.needleColor = "#FAA700";
                      } else if (
                        emPowerFactorFrequencyAccelerationData.centralLabel > emPowerFactorFrequencyAccelerationData.options.arcLabels[1] &&
                        emPowerFactorFrequencyAccelerationData.centralLabel <= emPowerFactorFrequencyAccelerationData.options.arcLabels[2]
                      ){
  
                        emPowerFactorFrequencyAccelerationData.options.needleColor = "#72FF13";
                      }else if (
                        emPowerFactorFrequencyAccelerationData.centralLabel > emPowerFactorFrequencyAccelerationData.options.arcLabels[2] &&
                        emPowerFactorFrequencyAccelerationData.centralLabel <= emPowerFactorFrequencyAccelerationData.options.arcLabels[3]
                      ){
                        if(chartName == 'Instantaneous Power (KW)'){ emPowerFactorFrequencyAccelerationData.options.needleColor = "#FAA700";}
                        if(chartName == 'Instantaneous Power (KVA)'){ emPowerFactorFrequencyAccelerationData.options.needleColor = "#72FF13"; }  
                        //emPowerFactorFrequencyAccelerationData.options.needleColor = "#72FF13";
                      }else if (
                        emPowerFactorFrequencyAccelerationData.centralLabel > emPowerFactorFrequencyAccelerationData.options.arcLabels[3] &&
                        emPowerFactorFrequencyAccelerationData.centralLabel <= emPowerFactorFrequencyAccelerationData.options.arcLabels[4]
                      ){
                        emPowerFactorFrequencyAccelerationData.options.needleColor = "#FAA700";
                      }else{
                        emPowerFactorFrequencyAccelerationData.options.needleColor = "#ff2a1b";
                      }
                      // console.log("PEAK DEMADN")
                      // console.log(emPowerFactorFrequencyAccelerationData)
                      //update range now. 
                      this.emPeakDemandData.push(emPowerFactorFrequencyAccelerationData);                   
                      this.gaugeShow=true;
                    }
                  
                  }
  
  
                  if(this.emPeakDemandData.length >=1){                  
                    setTimeout(() => {
                      this.peakdemandloading=false;
                    }, 1000);
                  }
                  
  
                }
  
              }
                  
            }
  
          }
  
        });
  }

  public async getEmeterGraphScaleSettingsDataByID(metric_type: string, generic_asset_id: any): Promise<any> {
    try {
      const sensorRes = await this.service.getDataWithQuery(`${this.emeterData}/emeter-graph-scale-settings/${metric_type}/${generic_asset_id}`).then(res =>{
        return res;
      });
      const sensorBody = JSON.parse(JSON.stringify(sensorRes)).data.body;
  
      if (sensorBody && Object.keys(sensorBody).length !== 0) {
        return sensorBody;
      } else {
        throw new Error('No data found in sensor response');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error; // Rethrow the error to be handled by the caller
    }
  }

  public async getEmeterVpfGraphScaleSettingsDataByID(metric_type: string, serial_number: string): Promise<any> {
    try {
      const sensorRes = await this.service.getDataWithQuery(`${this.emeterData}/emeter-graph-scale-vpf-settings/${metric_type}/${serial_number}`).then(res =>{
        return res;
      });
      const sensorBody = JSON.parse(JSON.stringify(sensorRes)).data.body;
  
      if (sensorBody && Object.keys(sensorBody).length !== 0) {
        return sensorBody;
      } else {
        throw new Error('No data found in sensor response');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error; // Rethrow the error to be handled by the caller
    }
  }

  public fetchAlertSettings=async ()=>{
    try {
      let roleId=this.role=='USER'?'3':'2'
      /* The above code is setting the variable `alertsLoader` to `true` in a TypeScript file. */
      this.alertsLoader=true;
      // const sensorRes = await this.service.getDataWithQuery(`${this.emeterData}/alert_settings/${this.subsystem_id}`).then(res =>{
      const sensorRes:any = await this.service.getDataV2(`${this.emeterData}/alerts_settings/${this.subsystem_id}/${roleId}`).then(res =>{
        return res;
      });
      const {code,body}=JSON.parse(JSON.stringify(sensorRes)).data;
      const {hadSettings,alertSettings}=body;
      this.alertSettings=alertSettings;
      this.alertSettings=this.alertSettings.map(alert=>{
        alert.name=this.extractAlertName(alert.alert_type_name)
        return alert;
      })
      if(hadSettings){
        this.hasConfiguredAlerts=true;
      }else{
        this.hasConfiguredAlerts=false

      }      
    } catch (error) {
      
    }finally{
      this.alertsLoader=false;
    }
  }

  openAlertSettings(){
      this.openAlertModal=true;
  }
  onTypeChange(i,value){
    this.alertSettings[i].type=value;
    if (value === 'event') {
      this.alertSettings[i].event_counter = '999';  // Default to 1 for event
    } else {
      this.alertSettings[i].event_counter = '999';  // Default to 6 for time
    }
  }

  onAlertValueChange(i,value){
    // value change like 1,2,3,4,5 or 6,12,24
    this.alertSettings[i].event_counter=value
  }

  async saveAlertSettings(){

    this.alertsSaveLoader=true;
    try {
      let roleId=this.role=='USER'?'3':'2'
    if(this.hasConfiguredAlerts){

      const body=this.alertSettings.map(alert=>{
        return {
          id:alert.id,
          event_counter:alert.event_counter,
          roleId:this.alertsRoleId,
          type:alert.type,
        }
      })
      const sensorRes:any = await this.service.putData(`${this.emeterData}/alerts_settings/${this.subsystem_id}/${this.alertsRoleId}`,body).then(res =>{
        return res;
      });
      const {code,status}=JSON.parse(JSON.stringify(sensorRes)).data;
      if(code==200 && status=='success'){
        this.hasConfiguredAlerts=true;
        this.openAlertModal=false;
      }else{
        console.warn('Error in saving alert settings')
      }
    }else{
      const bodyObj=this.alertSettings.map(alert=>{
        return {
          catId:4,
          roleId:this.alertsRoleId,
          alertTypeId:alert.id,
          client_id:this.userID,
          type:alert.type,
          event_counter:alert.event_counter,
        }
      })
      const sensorRes:any = await this.service.postData(`${this.emeterData}/alerts_settings/${this.subsystem_id}/${this.alertsRoleId}`,bodyObj).then(res =>{
        return res;
      });
      const {code,status}=JSON.parse(JSON.stringify(sensorRes)).data;
      if(code==200 && status=='success'){
        this.hasConfiguredAlerts=true;
        this.openAlertModal=false;
        this.service.showSuccess('Alert Settings Updated!')
        this.fetchAlertSettings()
      }else{
        console.warn('Error in saving alert settings')
      }

    }
    } catch (error) {
      this.service.showError('Error saving alert settings!')
      
    }finally{
      this.alertsSaveLoader=false;
    }
  }
  closeAlertModal(){
    this.openAlertModal=false;
  }

  async changeAlertsBasedOnRole(value){
    try {
      /* The above code is setting the variable `alertsLoader` to `true` in a TypeScript file. */
      this.alertsLoader=true;
      // const sensorRes = await this.service.getDataWithQuery(`${this.emeterData}/alert_settings/${this.subsystem_id}`).then(res =>{
      const sensorRes:any = await this.service.getDataV2(`${this.emeterData}/alerts_settings/${this.subsystem_id}/${value}`).then(res =>{
        return res;
      });
      const {code,body}=JSON.parse(JSON.stringify(sensorRes)).data;
      const {hadSettings,alertSettings}=body;
      this.alertSettings=alertSettings
      this.alertSettings=this.alertSettings.map(alert=>{
        alert.name=this.extractAlertName(alert.alert_type_name)
        return alert;
      })
      if(hadSettings){
        this.hasConfiguredAlerts=true;
      }else{
        this.hasConfiguredAlerts=false

      }      
    } catch (error) {
      
    }finally{
      this.alertsLoader=false;
    }
  }

  extractAlertName(name: string): string {
    switch (name) {
      case 'meter_overload':
        return 'Meter Overload';
      case 'abnormal_pf':
        return 'Abnormal Power Factor';
      case 'abnormal_freq':
        return 'Abnormal Frequency';
      case 'current_unbalance':
        return 'Current Unbalance';
      case 'voltage_unbalance':
        return 'Voltage Unbalance';
      case 'abnormal_thd':
        return 'Abnormal Total Harmonic Distortion';
      case 'under_voltage':
        return 'Under Voltage';
      case 'meter_underload':
        return 'Meter Underload';
      default:
        return 'Unknown Alert';  // ✅ This ensures all paths return a value
    }
  }
  
}
